var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g5, _g6, _path8, _g7, _path9, _g8, _path10, _path11, _path12, _g9, _path13, _path14, _path15, _path16, _g10, _path17, _path18, _path19, _path20, _g11, _path21, _path22, _g12, _path23, _g13, _path24, _path25, _path26, _path27, _g14, _path28, _path29, _g15, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g16, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g17, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g18, _g19, _path56, _path57, _path58, _path59, _path60, _g20, _path61, _path62, _path63, _g21, _g22, _path64, _path65, _path66, _path67, _path68, _g23, _path69, _path70, _path71, _g24, _path72, _path73, _path74, _path75, _g25, _g26, _path76, _path77, _path78, _path79, _path80, _path81, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _g34, _g35, _g36, _g37, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarwash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 816.702,
    height: 652.303,
    viewBox: "0 0 816.702 652.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.494,
    y1: 0.5,
    x2: 0.658,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc9a11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1b527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.501,
    y1: 0.5,
    x2: 0.66,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.54,
    y1: 0.5,
    x2: 0.146,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.413,
    y1: 0.23,
    x2: 0.604,
    y2: 0.746,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#c18c68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#e2b489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#d6a880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3a57d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.364,
    y1: 0.261,
    x2: 0.666,
    y2: 0.725,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#e2b489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#d6a880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#d3a57d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.364,
    y1: 0.102,
    x2: 0.663,
    y2: 0.863,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.244,
    y1: 0.185,
    x2: 0.812,
    y2: 0.796,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.381,
    y1: 0.198,
    x2: 0.722,
    y2: 0.743,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#f2c496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ebbd90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#dfb187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d3a57d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.364,
    y1: 0.102,
    x2: 0.663,
    y2: 0.863,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.381,
    y1: 0.198,
    x2: 0.722,
    y2: 0.743,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.34,
    y1: 0.029,
    x2: 0.661,
    y2: 0.974,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#a6e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#adebc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#b9f1c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#caf8cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9ffd1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M261.671,223.613c-13.826-8.337-25.311-2.173-25.662,13.763s10.576,35.614,24.4,43.951,25.315,2.165,25.662-13.771S275.493,231.942,261.671,223.613Z",
    transform: "translate(-236.001 -219.897)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M185.063,179.383c-13.826-8.337-25.315-2.169-25.662,13.767s10.572,35.61,24.4,43.947,25.315,2.169,25.662-13.771S198.885,187.716,185.063,179.383Z",
    transform: "translate(-159.393 -175.668)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.602,
    y1: 0.17,
    x2: 0.38,
    y2: 0.74,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75ae8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.389,
    y1: 0.228,
    x2: 0.635,
    y2: 0.918,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#a6e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#adebc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#b9efc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcf1ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1.037,
    y1: 0.199,
    x2: 0.223,
    y2: 0.745,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcf1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#b9efc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#adebc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#a6e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5e8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75ae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88c399"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 2.976, -0.855)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 2.282, -1.583)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(2.59 -0.628) rotate(-29.241)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 2.633, -0.431)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(3.601 -0.449) rotate(-29.241)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 1.829, -1.223)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 5.104,
    y1: 44.963,
    x2: 5.127,
    y2: 40.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#050607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#708fa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9bc6ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 5.076,
    y1: 28.45,
    x2: 5.099,
    y2: 25.67,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 5.126,
    y1: 77.151,
    x2: 5.149,
    y2: 69.527,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 5.144,
    y1: 115.354,
    x2: 5.167,
    y2: 103.952,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddcdb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e3148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2.761,
    y1: 8.708,
    x2: 2.784,
    y2: 4.301,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2.761,
    y1: 5.661,
    x2: 2.785,
    y2: 2.89,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2.761,
    y1: 14.685,
    x2: 2.784,
    y2: 7.068,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2.761,
    y1: 38.086,
    x2: 2.784,
    y2: 17.905,
    xlinkHref: "#linear-gradient-17"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-123.847 -104.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(123.847 104.016)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(0 427.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M172.357,275.228c-13.244,0-26.489-2.91-36.57-8.727s-15.648-13.678-15.648-22.1,5.555-16.276,15.648-22.1c20.169-11.645,52.974-11.645,73.139,0,10.092,5.825,15.652,13.674,15.652,22.1s-5.559,16.276-15.652,22.1S185.6,275.228,172.357,275.228Zm0-58.3c-12.624,0-25.248,2.774-34.861,8.321-8.988,5.193-13.939,11.988-13.939,19.143s4.951,13.951,13.939,19.139c19.221,11.1,50.5,11.1,69.722,0,8.992-5.189,13.943-11.985,13.943-19.139s-4.951-13.951-13.943-19.143C197.61,219.707,184.982,216.933,172.357,216.933Z",
    transform: "translate(-120.14 -213.563)",
    fill: "#3d3838"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(97.615 350.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(140.247 32.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M294.368,471.767c-20.692,0-39.523-5.91-53.442-17.271-6.144-5.021-10.541-11.274-15.2-17.895-9.211-13.1-18.737-26.657-43.19-30.788a1.707,1.707,0,1,1,.57-3.367c25.857,4.365,36.25,19.147,45.418,32.189,4.518,6.425,8.785,12.488,14.563,17.208,20.079,16.4,50.988,20.9,82.7,12.059,28.307-7.9,46.4-18.612,69.3-32.177,28.994-17.165,65.068-38.528,137.595-62.466,7.455-2.458,16.342-3.854,25.748-5.337,27.035-4.252,57.671-9.07,66.433-41.357,6.675-24.585-11.107-72.149-28.771-88.385-16.26-14.949-39.039-24.6-67.69-28.682a1.708,1.708,0,1,1,.48-3.382c29.353,4.178,52.744,14.122,69.527,29.548,18.3,16.822,36.7,66.215,29.754,91.8-9.343,34.42-41.146,39.425-69.2,43.838-9.269,1.455-18.02,2.836-25.206,5.2-72.18,23.821-108.079,45.082-136.928,62.161-23.126,13.7-41.388,24.511-70.132,32.528A120.659,120.659,0,0,1,294.368,471.767Z",
    transform: "translate(-181.112 -202.097)",
    fill: "#3d3838"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M507.575,454.774c-45.55,0-78.437-16.459-110.419-32.466-22.35-11.185-43.455-21.749-68.567-27.078-19.892-4.225-41.294-3.761-61.99-3.308-32.356.695-65.817,1.416-93.246-16.1-14.516-9.269-28.139-32.805-24.476-51.757,1.943-10.049,2.934-23.766-3.363-32a1.712,1.712,0,1,1,2.719-2.079c7.065,9.246,6.074,23.988,4,34.728-3.078,15.917,7.65,38.454,22.955,48.23C201.741,389.9,233.2,389.226,266.524,388.5c20.895-.445,42.5-.917,62.77,3.386,25.541,5.419,47.832,16.576,69.39,27.367,37.974,19.007,77.267,38.645,137.665,29.981,5.122-.733,10.318-1.689,15.347-2.618,10.67-1.966,21.706-4,32.793-4.069,10.049.031,18.964,2.188,27.515,4.354,11.071,2.8,21.53,5.458,33.827,3.012,18.839-3.749,25.248-9.5,32.668-16.147,5.934-5.321,12.667-11.356,26.61-17.247,5.056-2.13,10.865-4.022,17.025-6.023,22.8-7.4,48.64-15.8,52.69-41.36,5.282-33.363-17.267-49.315-45.823-69.511-26.45-18.71-59.368-42-80.115-86.673-6.238-13.44-26.563-15.581-38.126-15.663a1.709,1.709,0,0,1,.012-3.417c12.379.086,34.182,2.493,41.216,17.641,20.36,43.853,52.869,66.847,78.987,85.323,29.524,20.879,52.841,37.373,47.228,72.835-4.377,27.632-32.454,36.749-55.014,44.079-6.086,1.974-11.828,3.843-16.744,5.918-13.42,5.672-19.642,11.251-25.662,16.646-7.795,6.987-14.528,13.018-34.28,16.951-13.053,2.594-23.883-.144-35.337-3.047-8.349-2.118-16.9-4.416-26.653-4.248-10.787.066-21.671,2.072-32.2,4.01-5.064.932-10.291,1.9-15.48,2.637A205.15,205.15,0,0,1,507.575,454.774Z",
    transform: "translate(-145.162 -193.87)",
    fill: "#3d3838"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(198.726 582.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M213.431,303.734c-10.717,0-21.433-2.36-29.591-7.069-8.228-4.748-12.761-11.169-12.761-18.074s4.533-13.322,12.761-18.07c16.315-9.421,42.866-9.417,59.185,0,8.228,4.748,12.757,11.169,12.757,18.07s-4.529,13.327-12.757,18.074C234.868,301.374,224.148,303.734,213.431,303.734Zm0-46.916c-10.1,0-20.2,2.224-27.882,6.663-7.127,4.112-11.052,9.48-11.052,15.109s3.925,11,11.052,15.109c15.371,8.887,40.393,8.887,55.764,0,7.127-4.108,11.052-9.476,11.052-15.109s-3.925-11-11.052-15.109C233.628,259.042,223.531,256.818,213.431,256.818Z",
    transform: "translate(-171.08 -253.456)",
    fill: "#3d3838"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(249.759 527.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M195.747,301.233a1.729,1.729,0,0,1-.62-.117c-14.345-5.567-11.938-19.057-7.7-31.522,1.284-3.761,2.836-7.7,4.338-11.5a154.665,154.665,0,0,0,6.168-17.579,1.709,1.709,0,1,1,3.312.843,157.143,157.143,0,0,1-6.3,17.992c-1.486,3.769-3.027,7.666-4.28,11.349-5.415,15.9-3.819,23.54,5.7,27.23a1.71,1.71,0,0,1-.62,3.3Z",
    transform: "translate(-184.161 -239.23)",
    fill: "#3d3838"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(17.445 216.529)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M799.247,361.655,304.35,159.519s-10.494,5.668-25.217,13.955l-34.17-13.955S129.6,221.829,125.84,236.162c-3.6,13.7,29.4,31.518,29.4,31.518L507.068,470.912c15.343,9.035,33.254,13.264,51.371,13.845l72.32-.2c22.467-1.315,44.384-7.845,61.229-17.458C794.374,408.664,834.455,388.608,799.247,361.655Z",
    transform: "translate(-121.844 -159.519)",
    fill: "#62575b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M283.239,239.106c2.895-3.714,2.758-8.044-.187-11.715-2.345-2.914-9.784-7.186-13.412-8.075-26.977-6.609-39.106-9.148-64.756-8.267-84.824,2.9-89.209,37.229-72.5,48.464,16.693,11.228,38.86,12.964,42.2,12.956,18.831-.039,37.292-10.674,54.683-16.7C258.5,245.629,274.126,250.8,283.239,239.106Z",
    transform: "translate(-124.612 -10.512)",
    fill: "#62575b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M206.045,217.071l-53.583,30.936a2.79,2.79,0,0,0,0,4.83L181.487,269.6a10.933,10.933,0,0,0,5.458,1.459h23.485Z",
    transform: "translate(-47.854 7.45)",
    fill: "#62575b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M355.964,197.886l-53.575,30.933a2.787,2.787,0,0,0,0,4.833l29.021,16.756a10.9,10.9,0,0,0,5.458,1.463h23.481Z",
    transform: "translate(387.097 -48.209)",
    fill: "#62575b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M340.082,230.411H330.7l-16.39-9.463,21.62-6.557,4.149,9.463Z",
    transform: "translate(425.746 -0.323)",
    fill: "#62575b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M342.817,215.3H306.883a2.352,2.352,0,0,0-1.174,4.389l12.932,7.467a7.883,7.883,0,0,0,3.944,1.057H348.45Z",
    transform: "translate(397.364 2.309)",
    fill: "#62575b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M193.767,257.99c-4.307,1.088-9.051,2.657-11.087,6.6-1.9,3.675-.667,8.384,2.044,11.516s6.613,4.954,10.514,6.339,7.962,2.423,11.6,4.393c3.148,1.7,5.891,4.057,8.883,6.023,9.027,5.93,19.947,8.149,30.628,9.764a362.828,362.828,0,0,0,42.874,3.9,11.5,11.5,0,0,0,5.017-.6c2.824-1.244,4.166-4.42,5.243-7.315a5.017,5.017,0,0,0,.464-2.243c-.261-2.4-3.421-3.043-5.836-3.035-5.9.023-11.871.211-17.61-1.147s-11.341-4.49-14.247-9.624c-2.391-4.217-2.719-9.25-4.046-13.911a40.735,40.735,0,0,0-8.5-15.351c-3.78-4.315-11.524-2.153-16.892-1.724A236.676,236.676,0,0,0,193.767,257.99Z",
    transform: "translate(41.195 104.863)",
    fill: "#62575b"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(709.474 291.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(0 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M402.388,201.938a3.887,3.887,0,0,1-2.29,3.2l-33.905,19.572a10.14,10.14,0,0,1-3.531,1.151,11.865,11.865,0,0,1-7.424-1.143l-49.99-29.1a3.847,3.847,0,0,1-2.243-3.144l.016,37.237a3.838,3.838,0,0,0,2.243,3.144l49.986,29.1a11.184,11.184,0,0,0,5.707,1.276,10.849,10.849,0,0,0,1.709-.133,10.131,10.131,0,0,0,3.538-1.151l33.905-19.576a3.874,3.874,0,0,0,2.29-3.2Z",
    transform: "translate(-299.088 -160.309)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M304.454,206.582c-3.254,1.876-3.269,4.919-.055,6.788l54.375,31.646A12.914,12.914,0,0,0,370.494,245l36.269-20.938c3.254-1.88,3.269-4.919.051-6.788l-54.367-31.646a12.926,12.926,0,0,0-11.719.008Z",
    transform: "translate(-302 -184.232)",
    fill: "#ffd742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M409.217,201.474c0,1.237-.815,2.477-2.454,3.425l-36.269,20.938a10.513,10.513,0,0,1-3.57,1.2,12.879,12.879,0,0,1-8.15-1.186L304.4,194.2a4.109,4.109,0,0,1-2.4-3.363l.016,5.278a4.109,4.109,0,0,0,2.4,3.363l54.375,31.646a12,12,0,0,0,6.554,1.307,10.956,10.956,0,0,0,5.161-1.315l36.273-20.941c1.638-.948,2.454-2.189,2.45-3.425Z",
    transform: "translate(-302.001 -165.064)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M399.249,215.649l-50.743-29.528a11.645,11.645,0,0,0-10.553.008l-32.661,18.858c-2.93,1.689-2.945,4.428-.043,6.109l50.743,29.528a11.645,11.645,0,0,0,10.553-.008l32.661-18.858C402.136,220.069,402.147,217.334,399.249,215.649Z",
    transform: "translate(-298.859 -182.407)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M331.755,209.889l-20.318-11.848,2.278-1.319a11.633,11.633,0,0,1,10.553,0l20.317,11.848-2.278,1.315A11.645,11.645,0,0,1,331.755,209.889Z",
    transform: "translate(-274.623 -151.672)",
    fill: "#ffd742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M353.462,235.034l-49.506-28.81,31.467-18.168a11.644,11.644,0,0,1,10.553-.008l49.51,28.81-31.471,18.168A11.645,11.645,0,0,1,353.462,235.034Z",
    transform: "translate(-296.329 -176.816)",
    fill: "#90a6bf",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M315.5,206.068l41.477-23.953a.542.542,0,0,1,.515,0,.528.528,0,0,1,.261.46v32.949l3.2,1.869V182.575a3.728,3.728,0,0,0-5.587-3.234L313.893,203.29a10.608,10.608,0,0,0-5.294,9.172V248.8a1.6,1.6,0,0,0,.8,1.385,1.543,1.543,0,0,0,.8.215,1.559,1.559,0,0,0,.8-.215l2.255-1.3a1.605,1.605,0,0,0-1.455-2.856v-33.57A7.394,7.394,0,0,1,315.5,206.068Z",
    transform: "translate(-282.859 -178.833)",
    fill: "#e2e2e2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(596.397 142.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(0 96.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(0 128.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M274.122,215.138c1.592-2.637,7.662-4.861,13.561-7.213,5.984-2.388,14.4-5.942,14.766-6.792.3-.7.156-1.6.675-2.161a2.179,2.179,0,0,1,1.241-.527,20.412,20.412,0,0,1,12.511,1.709c1.787.87,3.87,4.486,3.87,4.486-.183,2.251.16,9.644-.328,10.545,0,0-8.938,3.628-9.382,3.792-.854.316-1.139-.745-1.873-.788-6.593,3.375-14.969,6.2-18.808,6.718-4.412.6-14.275,2.29-16.631-2.824A7.634,7.634,0,0,1,274.122,215.138Z",
    transform: "translate(-272.849 -198.118)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(0 13.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M273.891,209.885c2.356,5.114,12.219,3.429,16.631,2.824,3.839-.523,30.449-11.2,30.449-11.2.25,2.743-.086,3.737-.386,4.287,0,0-8.938,3.628-9.382,3.792-.854.32-1.139-.285-1.872-.324a70.693,70.693,0,0,1-18.808,6.258c-4.412.6-14.59,2.286-16.951-2.828a6.543,6.543,0,0,1-.257-4.6A9.435,9.435,0,0,0,273.891,209.885Z",
    transform: "translate(-273.016 -201.509)",
    fill: "#e58d2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(100.158 143.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M317.537,242.4c-5.879,4.826-14.5,3.612-17.513.866-4.3-3.928,3.152-15.223,3.964-28.756.047-.8-.386-7.319-.051-7.514,4.759-2.77,16.837-7.272,20.068-3.179,1.19,1.51.808,7.124.866,8.941C325.266,224.322,325.874,235.565,317.537,242.4Z",
    transform: "translate(-298.665 -202.174)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M299.347,238.191c3,2.747,11.633,3.96,17.512-.862,8.337-6.839,7.728-18.082,7.334-29.645-.031-.96.055-2.961-.023-4.869,1.061,1.693.714,6.995.772,8.758.394,11.563,1,22.806-7.334,29.645-5.879,4.822-14.509,3.609-17.513.866a5.61,5.61,0,0,1-1.373-4.7A5.62,5.62,0,0,0,299.347,238.191Z",
    transform: "translate(-298.689 -200.313)",
    fill: "#e58d2e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M332.676,191.611c1.33,14.1,2.992,27.968,3.87,39.566a41.863,41.863,0,0,0,.886,6.8,50.659,50.659,0,0,0,2.368,6.675c6.765,17.122,12.183,48.675,14.945,66.765.968,6.351-20.177,9.913-22.1,2.485-.624-2.419-9.531-33.125-13.81-44.45-2.665-7.049-7.56-16.081-9.316-22.225-1.529-5.372-12.492-43.194-17.4-55.483-1.615-4.053-3.343-8.165-3.6-12.519l38.54-13.584C329.111,170.5,332.119,182.584,332.676,191.611Z",
    transform: "translate(-228.038 -164.162)",
    fill: "#211921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M318.487,228.734c-.425,2.622-.714,12.265-3.043,22.787-4.338,19.619-11.8,44.579-12.492,48.917-.991,6.144-24,2.349-22.795-4.428,0,0,8.193-70.139,8.274-71.216.211-2.618.417-5.239.425-7.869.008-3.464.277-7.927.5-11.388.967-14.782,1.584-28.3,2.984-40.276,10.841.48,32.77,18.882,33.378,25.635.277,3.141,1.561,6.421.952,9.457C324.714,210.075,320.079,218.942,318.487,228.734Z",
    transform: "translate(-252.427 -165.262)",
    fill: "#211921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(39.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M341.693,226.491c.975,4.334,4.428,14.1,3.57,18.585-1.915,9.979-27.667,11.727-41.107,8.2-11.38-2.984-19.568-5.3-20.946-13.069-.265-1.5,2.9-39.168,2.8-43.077-.32-12.347-1.959-26.477-2.473-31.986-1.233-13.143-.285-7.611,5.945-18.024a10.643,10.643,0,0,1,3.258-3.745c1.3-.815,4.494-2.828,6.031-2.871,10.065-.261,48.656,15.6,50.587,17.146,3.519,2.82,3.722,7.537,3.753,12.043s-1.26,8.906-2.544,13.225C345.957,198.464,338.943,209.985,341.693,226.491Z",
    transform: "translate(-283.07 -140.505)",
    fill: "#ffd940"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M305.393,172.824l5.712,6.347a5.5,5.5,0,0,0,.476.4,3.11,3.11,0,0,0,1.233.417l6.468.453a6.868,6.868,0,0,1,3.695,1.576l.956.753a13.608,13.608,0,0,1,1.315,1.248l12.331,13.795a9.134,9.134,0,0,1,1.674,8.118l-4.085,11.38a3,3,0,0,1-2.013,1.627c.016.023-4.1.854-4.1.854a3.03,3.03,0,0,1-2.473-.745l-.967-.749a4.738,4.738,0,0,1-.6-.57l-14.181-15.854a11.8,11.8,0,0,1-1.451-2.036l-4.478-7.83a23.524,23.524,0,0,0-2.875-4.03l-5.555-6.214Z",
    transform: "translate(-204.956 -46.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(80.245 118.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M293.585,174.859l3.082-.619,2.221,2.5-3.082.619Z",
    transform: "translate(-293.585 -161.59)",
    fill: "#f1b527"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M298.816,173.439a2.767,2.767,0,0,1,1.787-1.4l5.068-1.03a2.773,2.773,0,0,0-1.787,1.4l-7.217,11.2-3.082.62Z",
    transform: "translate(-293.585 -170.965)",
    fill: "#ffd742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M301.592,172.446c1.135-1.9,3.117-1.935,4.771-.082l5.325,5.949-2.875,8.489-5.341,1.276-3.671-3.811-3.207,1.88-2.22-2.5Z",
    transform: "translate(-291.293 -170.998)",
    fill: "#dc9a11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(84.764 16.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M298.585,240.251c2.575-.7,3.277-.784,4.962-2.271,1.174-1.038,4.923-3.753,4.923-3.979,6.4-18.878,15.312-41.852,15.23-42.109-1.533-4.623-10-17.852-15.831-31.319q1.966-1.533,3.936-3.066c3.687-2.864,8.029-5.481,12.105-8.352l13.1,33.776c1.112,2.871,2.5,5.856,2.157,8.918-.85,7.65-4.529,16.2-7.962,22.1-4.3,7.389-9.671,15.628-14.271,24.858-.242.48-1.081,5.879-1.393,8.056a14.316,14.316,0,0,1-1.139,4.447c-.644,1.276-4.724,4.7-6.905,5.344a3.994,3.994,0,0,1-3.589-.8c-.4-.331-.663-.8-1.03-1.163-.862-.858-2.158-1.1-3.172-1.771a8.2,8.2,0,0,1-1.151-.96c-.718-.671-2.278-1.65-1.919-2.836.273-.882,1.416-1.33,2.173-1.67,1.525-.687,4.838-3.269,4.787-4.241-.8-.967-7.759,2.243-8.778-.78C294.442,241.331,295.487,241.1,298.585,240.251Z",
    transform: "translate(-294.743 -131.478)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M306.518,187.528c-3.589-7.771-8.048-17.021-9.441-25.463-.632-3.827-.835-7.869.612-11.466s4.892-5.977,7.876-5.977a9.972,9.972,0,0,1,5.029,1.5c5.15,3.148,13.256,24.355,15.64,30.78C328.415,182.769,308.09,190.938,306.518,187.528Z",
    transform: "translate(-289.37 -144.623)",
    fill: "#ffd940"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(85.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(486.937 180.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M294.133,150.524a2.782,2.782,0,0,0-2.813.269l-20.54,12.043a8.749,8.749,0,0,0-3.956,6.882l-.059,10.522a2.815,2.815,0,0,0,1.163,2.571L269.973,184a2.8,2.8,0,0,1-1.17-2.571l.066-10.521a8.755,8.755,0,0,1,3.952-6.882l20.544-12.043a2.79,2.79,0,0,1,2.813-.269Z",
    transform: "translate(-266.766 -150.254)",
    fill: "#494443"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(2.036 1.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M291.85,151.1c2.181-1.26,3.971-.238,3.975,2.3l-.059,10.518a8.761,8.761,0,0,1-3.956,6.886l-20.54,12.039c-2.185,1.26-3.975.242-3.983-2.3l.066-10.522a8.756,8.756,0,0,1,3.952-6.882Z",
    transform: "translate(-267.288 -150.558)",
    fill: "#383534"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M281.05,155.957c-1.026-2.848-5.594-.191-4.057,2.419.035.055,3.624,6.215,1.845,12.9-1.135,4.272-4.26,7.884-9.3,10.736a2.414,2.414,0,0,0-.9,3.215c1.35,2.7,3.343,2.317,3.71,2.111A23.727,23.727,0,0,0,283.4,172.482C285.681,163.9,281.175,156.312,281.05,155.957Z",
    transform: "translate(-262.117 -137.269)",
    fill: "#302c26"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(12.051 60.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 191.859,
    height: 66.344,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 95.93)",
    fill: "#8bcca2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 191.859,
    height: 66.345,
    transform: "translate(1.948 97.399) rotate(-30)",
    fill: "#a75"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M618.168,335.579l-56.005-77.489c-3.066-5.938-7.533-10.939-12.285-13.681L307.595,105.073c-3.074-1.775-5.731-.843-6.4,2.22l-.016,2.239.737,1.085-31.6,110.505L153.182,288.753,421.97,466.861s231.255-68.294,251.56-88.393ZM515.146,277.6l-20.54-55.572,56.575,31.416,49.385,71.52Z",
    transform: "translate(-109.358 -103.543)",
    fill: "#a75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(23.039 75.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M298.721,166.681c-1.869-9.749-2.977-20.091-4.44-30.375-38.587,22.51-93.808,53.341-129.106,77.856l8.267,59.571,131.79-76.089Q301.727,182.231,298.721,166.681Z",
    transform: "translate(-97.6 -85.723)",
    fill: "#a75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M353.938,173.56c.183.066,26.676-26.684,26.676-26.684l-69.2-23.536L147.854,217.772l52.588,44.411Z",
    transform: "translate(-147.854 -123.34)",
    fill: "#eab88c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(97.822 1.433)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube",
    "data-name": "Axonometric Cube",
    transform: "translate(11.95 104.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left",
    "data-name": "Cube face - left",
    d: "M230.948,228.623l-54.956-31.728v-27l54.956,31.728Z",
    transform: "translate(-175.992 -94.073)",
    fill: "#2d2b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right",
    "data-name": "Cube face - right",
    d: "M321.413,185.591,190.079,261.417v-27L321.413,158.6Z",
    transform: "translate(-135.123 -126.868)",
    fill: "#383534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top",
    "data-name": "Cube face - top",
    d: "M230.948,258.015l-54.956-31.728,131.333-75.825,54.956,31.728Z",
    transform: "translate(-175.992 -150.462)",
    fill: "#2b2b2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    style: {
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M374.274,190.611a20.484,20.484,0,0,0-1.049-3.519c-.1-.254-.2-.5-.312-.753a18.555,18.555,0,0,0-3.074-4.779c-2.672-3.039-6.32-5.43-10.619-7.912-2.637-1.521-5.52-3.078-8.571-4.845-7.877-4.545-32.7-17.626-40.545-21.706a2.08,2.08,0,0,0-2.029-.113L174.7,224.219l64.089,51.047,133.374-77.24C374.048,196.934,375.019,194.344,374.274,190.611Z",
    transform: "translate(-167.788 -56.798)",
    fill: "url(#linear-gradient-4)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M241.6,210.412a20.873,20.873,0,0,0-1.049-3.523c-2.352-6.043-7.412-9.636-14.005-13.444-2.637-1.521-5.52-3.078-8.571-4.841-7.876-4.549-32.7-17.629-40.545-21.71-1.56-.8-2.844-.074-2.93,1.67-.5,10.471,4.358,15.71,10.951,19.518,5.4,3.117,16.615,8.056,22.291,11.333a186.212,186.212,0,0,1,23.922,16.658,12.869,12.869,0,0,0,1.689,1.174C238.562,220.255,242.962,217.247,241.6,210.412Z",
    transform: "translate(-168.485 0.641)",
    fill: "#c18c68"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M325.055,194.965c-10.085-51.359-4.287-51.886-6.96-61.885a13.782,13.782,0,0,0-.706-2,14.153,14.153,0,0,0-2.321-3.636,12.427,12.427,0,0,0-3.109-2.586c-1.951-1.127-3.917-1.521-5.224-.761L173.361,201.332l19.892,95.415,133.374-77.24a1.091,1.091,0,0,0,.453-.991A112.816,112.816,0,0,0,325.055,194.965Z",
    transform: "translate(-171.676 -123.707)",
    fill: "url(#linear-gradient-5)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M192.934,214.763c-10.085-51.359-4.288-51.886-6.96-61.884a13.745,13.745,0,0,0-6.137-8.216c-3.226-1.865-6.488-1.732-6.749,2.313-1.026,17.438,3.156,45.57,4.912,64.9.57,6.254,1.443,12.648,1.205,17.8a3.314,3.314,0,0,0,1.5,2.688l12.745,6.847c.835.48,1.506.066,1.506-.889A112.5,112.5,0,0,0,192.934,214.763Z",
    transform: "translate(-172.929 -66.269)",
    fill: "#c18c68"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(190.184 57.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(87.608)"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-2",
    "data-name": "Axonometric Cube",
    transform: "translate(11.953 111.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-2",
    "data-name": "Cube face - left",
    d: "M277.081,234.227,222.125,202.5v-27l54.956,31.728Z",
    transform: "translate(-222.125 -141.215)",
    fill: "#2d2b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-2",
    "data-name": "Cube face - right",
    d: "M295.6,201.845,236.212,236.13v-27L295.6,174.847Z",
    transform: "translate(-181.256 -143.119)",
    fill: "#383534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-2",
    "data-name": "Cube face - top",
    d: "M277.081,232.729,222.125,201l59.387-34.288,54.956,31.728Z",
    transform: "translate(-222.125 -166.714)",
    fill: "#2b2b2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(0 6.847)",
    style: {
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M348.464,206.863a20.871,20.871,0,0,0-1.053-3.519c-.1-.257-.2-.507-.312-.753a18.554,18.554,0,0,0-3.074-4.779c-2.668-3.039-6.32-5.431-10.619-7.912-2.633-1.525-5.52-3.082-8.571-4.845-7.873-4.545-32.7-17.626-40.541-21.71a2.1,2.1,0,0,0-2.029-.113l-61.432,35.7,64.093,51.043,61.424-35.7C348.234,213.183,349.206,210.593,348.464,206.863Z",
    transform: "translate(-213.92 -73.049)",
    fill: "url(#linear-gradient-6)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M287.733,216.016a20.8,20.8,0,0,0-1.053-3.523c-2.349-6.047-7.408-9.636-14.005-13.443-2.633-1.521-5.52-3.078-8.571-4.841-7.877-4.545-32.7-17.63-40.545-21.71-1.557-.8-2.84-.074-2.93,1.67-.5,10.471,4.362,15.71,10.955,19.518,5.4,3.117,16.615,8.056,22.291,11.333a185.86,185.86,0,0,1,23.918,16.658,13.271,13.271,0,0,0,1.689,1.174C284.694,225.859,289.094,222.851,287.733,216.016Z",
    transform: "translate(-214.617 -46.502)",
    fill: "#c18c68"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M299.238,211.218c-10.081-51.359-4.283-51.886-6.96-61.885a13.629,13.629,0,0,0-.706-2,14.267,14.267,0,0,0-2.317-3.64,12.577,12.577,0,0,0-3.113-2.583c-1.951-1.127-3.917-1.521-5.224-.765l-61.424,35.7,19.888,95.411,61.428-35.7a1.091,1.091,0,0,0,.453-.991A112.824,112.824,0,0,0,299.238,211.218Z",
    transform: "translate(-217.805 -139.959)",
    fill: "url(#linear-gradient-7)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M239.066,220.37c-10.085-51.363-4.284-51.89-6.96-61.888a13.745,13.745,0,0,0-6.137-8.216c-3.226-1.865-6.488-1.728-6.749,2.313-1.026,17.438,3.16,45.57,4.915,64.9.569,6.254,1.44,12.648,1.206,17.8a3.3,3.3,0,0,0,1.5,2.688l12.741,6.847c.835.48,1.506.066,1.51-.889A112.8,112.8,0,0,0,239.066,220.37Z",
    transform: "translate(-219.061 -113.411)",
    fill: "#c18c68"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(17.06 17.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M234.4,162.416l26.228-15.141s-4.666-4.525-9.546-4.475L223.434,158.87c1.007-.515,2.3-.991,5.1,1.358C232.352,163.442,234.4,162.416,234.4,162.416Z",
    transform: "translate(-223.434 -142.801)",
    fill: "#c18c68"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(17.982)",
    style: {
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M257.457,143.8a4.243,4.243,0,0,0-.371-1.6,5.64,5.64,0,0,0-.924-1.424,7.749,7.749,0,0,0-1.923-1.553c-1.771-1.022-3.866-1.369-5.157-.616l-24.574,14.278,8.005,21.761,24.573-14.278a2.7,2.7,0,0,0,1-2.754C257.574,152.065,257.535,146.7,257.457,143.8Z",
    transform: "translate(-221.241 -138.204)",
    fill: "url(#linear-gradient-8)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M235.318,147.461a5.845,5.845,0,0,0-3.219-4.576c-2.126-1.229-4.717-1.475-5.824-.035-2.1,2.661-2.758,8.879-2.575,12.925a6.051,6.051,0,0,0,2.692,4.5l6.094,3.519c2.087,1.205,3.706.027,3.46-2.516C235.431,155.724,235.4,150.356,235.318,147.461Z",
    transform: "translate(-223.671 -127.585)",
    fill: "#c18c68"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-3",
    "data-name": "Axonometric Cube",
    transform: "translate(57.257 134.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-3",
    "data-name": "Cube face - left",
    d: "M322.621,263.273l-111.34-64.282,13.256-23,98.084,56.63Z",
    transform: "translate(-211.281 -162.791)",
    fill: "#c18c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-3",
    "data-name": "Cube face - top",
    d: "M312.763,242.433,214.679,185.8l22.859-13.2,98.084,56.628Z",
    transform: "translate(-201.423 -172.606)",
    fill: "#f4c698"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M233.111,174.564l-16.447,9.5c-1.49.862-1.486,2.267,0,3.125l36.367,21a5.983,5.983,0,0,0,5.411,0l16.447-9.5c1.49-.862,1.49-2.259,0-3.121l-36.367-21A5.991,5.991,0,0,0,233.111,174.564Zm41,21.449a1.175,1.175,0,0,1,0,2.224l-16.447,9.5a4.264,4.264,0,0,1-3.85,0l-36.367-21a1.177,1.177,0,0,1,0-2.228l16.444-9.5a4.268,4.268,0,0,1,3.858,0Z",
    transform: "translate(-141.645 -34.586)",
    fill: "#c18c68",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(0 50.581)"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-4",
    "data-name": "Axonometric Cube",
    transform: "translate(11.954 111.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-4",
    "data-name": "Cube face - left",
    d: "M254.622,247.192l-54.954-31.728v-27L254.622,220.2Z",
    transform: "translate(-199.669 -154.18)",
    fill: "#2d2b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-3",
    "data-name": "Cube face - right",
    d: "M273.141,214.81,213.755,249.1v-27l59.386-34.288Z",
    transform: "translate(-158.801 -156.084)",
    fill: "#383534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-4",
    "data-name": "Cube face - top",
    d: "M254.622,245.695l-54.954-31.728,59.386-34.288,54.954,31.728Z",
    transform: "translate(-199.669 -179.679)",
    fill: "#2b2b2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(0 6.846)",
    style: {
      isolation: "isolate"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M326,219.832a21.241,21.241,0,0,0-1.049-3.523c-.1-.254-.207-.507-.312-.753a18.467,18.467,0,0,0-3.078-4.779c-2.672-3.039-6.316-5.43-10.619-7.912-2.633-1.525-5.516-3.082-8.571-4.841-7.873-4.549-32.7-17.63-40.541-21.714a2.089,2.089,0,0,0-2.029-.109l-61.428,35.7,64.089,51.047,61.428-35.7C325.774,226.152,326.749,223.561,326,219.832Z",
    transform: "translate(-191.462 -86.015)",
    fill: "url(#linear-gradient-9)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M265.275,228.981a20.392,20.392,0,0,0-1.049-3.519c-2.352-6.047-7.412-9.64-14.005-13.447-2.637-1.521-5.52-3.078-8.571-4.841-7.876-4.545-32.7-17.626-40.545-21.71a1.844,1.844,0,0,0-2.934,1.67c-.5,10.471,4.362,15.71,10.955,19.518,5.4,3.117,16.615,8.056,22.291,11.333a186.175,186.175,0,0,1,23.922,16.662,12.968,12.968,0,0,0,1.689,1.17C262.24,238.823,266.641,235.816,265.275,228.981Z",
    transform: "translate(-192.161 -59.468)",
    fill: "#c18c68"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M276.781,224.182C266.7,172.823,272.5,172.3,269.825,162.3a14.086,14.086,0,0,0-.706-2,14.367,14.367,0,0,0-2.321-3.636,12.333,12.333,0,0,0-3.109-2.583c-1.955-1.127-3.917-1.525-5.224-.768l-61.428,35.7,19.892,95.411,61.428-35.7a1.076,1.076,0,0,0,.449-.991A112.559,112.559,0,0,0,276.781,224.182Z",
    transform: "translate(-195.349 -152.924)",
    fill: "url(#linear-gradient-7)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M216.608,233.33c-10.081-51.355-4.284-51.882-6.956-61.885a13.775,13.775,0,0,0-6.137-8.216c-3.226-1.861-6.488-1.728-6.753,2.313-1.022,17.438,3.164,45.57,4.919,64.9.566,6.25,1.44,12.648,1.2,17.793a3.315,3.315,0,0,0,1.5,2.692l12.745,6.843c.835.484,1.5.066,1.506-.889A112.34,112.34,0,0,0,216.608,233.33Z",
    transform: "translate(-196.604 -126.376)",
    fill: "#c18c68"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(17.062 17.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M211.944,175.382l26.224-15.141s-4.662-4.525-9.542-4.475l-27.648,16.069c1.006-.515,2.3-.991,5.095,1.358C209.9,176.407,211.944,175.382,211.944,175.382Z",
    transform: "translate(-200.978 -155.766)",
    fill: "#c18c68"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(17.985)",
    style: {
      isolation: "isolate"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M235,156.766a4.248,4.248,0,0,0-.375-1.6,5.515,5.515,0,0,0-.925-1.42,7.621,7.621,0,0,0-1.923-1.557c-1.771-1.022-3.866-1.365-5.157-.616l-24.57,14.278,8.005,21.765,24.574-14.278a2.707,2.707,0,0,0,1-2.758C235.115,165.032,235.076,159.66,235,156.766Z",
    transform: "translate(-198.785 -151.17)",
    fill: "url(#linear-gradient-11)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M212.862,160.425a5.855,5.855,0,0,0-3.222-4.576c-2.126-1.225-4.717-1.475-5.824-.035-2.1,2.664-2.754,8.879-2.571,12.925a6.039,6.039,0,0,0,2.692,4.5l6.09,3.519c2.087,1.205,3.706.027,3.464-2.516C212.975,168.692,212.936,163.32,212.862,160.425Z",
    transform: "translate(-201.214 -140.551)",
    fill: "#c18c68"
  }))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(316.343 140.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M276.753,160.908c-13.845,4.736-27.1,18.714-29.54,31.151s6.835,18.7,20.684,13.962,27.1-18.714,29.544-31.151S290.6,156.168,276.753,160.908Zm-.281,3.932c.854-.289,1.635-.429,2.442-.624l-6.324,19.4-15.6-4.217C261.893,172.967,269.079,167.369,276.472,164.841Zm17.793,12.012c-2.1,10.7-13.506,22.724-25.412,26.8s-19.9-1.315-17.8-12.012a28.6,28.6,0,0,1,4.206-9.671l19.248,5.2,7.658-23.516C290.77,162.863,296.009,167.989,294.265,176.852Z",
    transform: "translate(-177.074 -159.325)",
    fill: "#3a3835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M387.76,169.412,374.648,162.8a5.253,5.253,0,0,0-4.186-.257c-51.73,18.96-105.082,52.908-141.52,86.13,4.205,6.039,6.351,13.252,7.681,20.735a10.475,10.475,0,0,1,6.18-.219c.347-.105,114.363-38.949,142.226-91.21C389.208,173.45,389.637,173.227,387.76,169.412Z",
    transform: "translate(-228.943 -150.925)",
    fill: "#ffd3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M308.534,165.668c-4.229,18.18-31.174,31.393-61.713,31.249,0,0,8.653-17.938,24.141-27.269C293.113,156.3,308.534,165.668,308.534,165.668Z",
    transform: "translate(-177.076 -150.189)",
    fill: "#ffd3ab"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M356.971,142.622l-136.4,79.936,30.686,123.335,174.17-108.852Z",
    transform: "translate(86.144 7.987)",
    fill: "#fffcee",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M275.683,142.622,267.7,147.3,248.588,296.755l95.549-59.714Z",
    transform: "translate(167.433 7.987)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(47.257 227.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    style: {
      isolation: "isolate"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M220.468,182.248l-66.406,38.6c.531-13.6,5.641-23.208,13.631-27.851l52.775-30.679Z",
    transform: "translate(-154.062 -162.317)",
    fill: "#1d1c1b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(345.523 393.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    style: {
      isolation: "isolate"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M308.654,224.774l-78.137,45.418c.511-13.6,5.618-23.216,13.607-27.858l64.529-37.506Z",
    transform: "translate(-230.517 -204.827)",
    fill: "#1d1c1b"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M232.8,228.669l131.248-76.214c2.313-1.346,4-.917,5.45,1.334l55.963,77.47,2.2-11.232L369.493,143.51,219.625,230.249l25.412,96.059,11.31.651-27.894-92.606C227.79,232.129,230.79,229.835,232.8,228.669Z",
    transform: "translate(83.406 10.565)",
    fill: "#649f78"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M303.462,104.458c1.2-.7,2.852-.585,4.65.453l241.87,139.5c4.748,2.742,9.219,7.744,12.281,13.681L412.394,344.829c-3.062-5.938-7.533-10.935-12.281-13.678L157.826,191.813c-1.795-1.038-3.449-1.147-4.646-.453Z",
    transform: "translate(-109.364 -104.016)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(53.573 249.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(298.862 172.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    style: {
      isolation: "isolate"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M317.791,256.353a95.284,95.284,0,0,0-15.316-24.082,70.092,70.092,0,0,0-17.29-14.555c-11-6.355-20.973-6.944-28.167-2.762L235.246,227.6c7.2-4.178,17.165-3.593,28.17,2.758a70.261,70.261,0,0,1,17.29,14.559A95.159,95.159,0,0,1,296.019,269c4.342,9.819,6.87,20.126,6.839,29.645-.035,12.476-4.439,21.254-11.54,25.385l21.769-12.652c7.1-4.128,11.5-12.909,11.544-25.385C324.657,276.483,322.133,266.176,317.791,256.353Z",
    transform: "translate(-223.71 -212.282)",
    fill: "#1d1c1b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M272,220.954c-21.862-12.616-39.632-2.489-39.706,22.592-.07,25.116,17.59,55.7,39.445,68.322s39.636,2.489,39.7-22.627C311.51,264.159,293.85,233.574,272,220.954Z",
    transform: "translate(-232.289 -202.873)",
    fill: "#2c2a29"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M263.645,223.1c-15.687-9.051-28.436-1.783-28.49,16.21-.047,18.02,12.624,39.968,28.307,49.026s28.436,1.787,28.487-16.233C292,254.106,279.327,232.162,263.645,223.1Z",
    transform: "translate(-223.977 -192.184)",
    fill: "#232221",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(12.932 27.692)",
    style: {
      isolation: "isolate"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M248.3,219.8l1.12-.062,7.186.811s1.561.215.476.507c-5.173,1.393-8.6,6.452-8.774,14.372-.293,13.463,8.93,30.078,20.606,37.116,7.085,4.268,13.443,4.034,17.411.179.792-.769-.5,1.853-.5,1.853l-2.345,4.182c-4.194,7.471-13.018,9.082-23.079,3.023-13.822-8.337-24.745-28.01-24.4-43.951C236.255,226.493,239.945,219.545,248.3,219.8Z",
    transform: "translate(-234.452 -218.339)",
    fill: "#c6c0b3"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M262.862,223.326c14.676,8.848,26.278,29.743,25.908,46.662s-12.57,23.47-27.25,14.625-26.278-29.743-25.908-46.67S248.182,214.474,262.862,223.326Zm-.039,1.787c-13.826-8.337-25.311-2.173-25.662,13.763s10.576,35.614,24.4,43.951,25.315,2.165,25.662-13.771-10.576-35.614-24.4-43.943Z",
    transform: "translate(-235.604 -219.381)",
    fill: "#e8dfd1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(14.481 29.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(8.113 -0.271)",
    style: {
      isolation: "isolate"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M261.638,223.335c12.519,7.744,22.272,25.8,21.788,40.327s-11.021,20.025-23.54,12.285-22.272-25.795-21.788-40.323S249.119,215.6,261.638,223.335Z",
    transform: "translate(-238.081 -219.828)",
    fill: "#a5a095"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M256.412,224.725c9.207,5.7,16.389,18.983,16.03,29.672s-8.111,14.739-17.321,9.035-16.389-18.979-16.034-29.669S247.2,219.03,256.412,224.725Z",
    transform: "translate(-235.196 -213.107)",
    fill: "#e8dfd1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M239.119,234.6l.012-.39c.359-10.7,7.3-15.476,16.131-11.875a22.076,22.076,0,0,1,3.336,1.717c5.895,3.644,11.044,10.053,14.317,17.111a36.753,36.753,0,0,1,3.7,16.233c-.4,12.02-9.117,16.568-19.467,10.163l-2.033-1.241c9.211,5.7,16.966,1.65,17.321-9.035a32.7,32.7,0,0,0-3.293-14.446c-2.914-6.281-7.5-11.981-12.737-15.226a20.134,20.134,0,0,0-2.973-1.525c-7.853-3.2-14.033,1.05-14.353,10.564,0,.117,0,.234-.008.347Z",
    transform: "translate(-235.193 -215.992)",
    fill: "#c6c0b3"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    style: {
      isolation: "isolate"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M241.183,212.125a95.234,95.234,0,0,0-15.316-24.086,70.174,70.174,0,0,0-17.294-14.555c-11-6.355-20.969-6.94-28.167-2.758l-21.769,12.652c7.2-4.182,17.165-3.593,28.167,2.758A70.174,70.174,0,0,1,204.1,200.69a95.278,95.278,0,0,1,15.316,24.082c4.338,9.819,6.862,20.13,6.835,29.645-.035,12.48-4.44,21.258-11.54,25.385l21.769-12.652c7.1-4.128,11.5-12.909,11.544-25.385C248.049,232.251,245.521,221.944,241.183,212.125Z",
    transform: "translate(-147.102 -168.053)",
    fill: "#1d1c1b"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M195.384,176.727c-21.858-12.62-39.628-2.493-39.7,22.588-.07,25.116,17.587,55.7,39.445,68.321s39.632,2.489,39.7-22.627C234.9,219.932,217.242,189.347,195.384,176.727Z",
    transform: "translate(-155.681 -158.645)",
    fill: "#2c2a29"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M187.036,178.876c-15.683-9.055-28.436-1.787-28.49,16.205-.047,18.024,12.62,39.968,28.307,49.026s28.436,1.787,28.486-16.237C215.39,209.879,202.719,187.931,187.036,178.876Z",
    transform: "translate(-147.369 -147.956)",
    fill: "#232221",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(12.932 27.691)",
    style: {
      isolation: "isolate"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M171.694,175.572l1.124-.062,7.182.811s1.56.215.476.507c-5.173,1.393-8.6,6.456-8.774,14.376-.293,13.459,8.93,30.074,20.606,37.112,7.081,4.272,13.44,4.034,17.411.183.792-.772-.5,1.849-.5,1.849l-2.348,4.186c-4.194,7.471-13.018,9.082-23.076,3.02-13.826-8.337-24.745-28.011-24.4-43.951C159.647,182.267,163.337,175.315,171.694,175.572Z",
    transform: "translate(-157.844 -174.11)",
    fill: "#c6c0b3"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M186.254,179.094c14.68,8.848,26.278,29.743,25.908,46.666s-12.57,23.47-27.25,14.618S158.634,210.639,159,193.712,171.574,170.247,186.254,179.094Zm-.039,1.787c-13.826-8.337-25.315-2.169-25.662,13.767s10.572,35.61,24.4,43.947,25.315,2.169,25.662-13.771-10.576-35.61-24.4-43.943Z",
    transform: "translate(-158.996 -175.151)",
    fill: "#e8dfd1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(14.481 29.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(8.113 -0.27)",
    style: {
      isolation: "isolate"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M185.03,179.108c12.519,7.74,22.272,25.795,21.788,40.323s-11.025,20.029-23.54,12.285S161,205.921,161.49,191.389,172.511,171.364,185.03,179.108Z",
    transform: "translate(-161.473 -175.598)",
    fill: "#a5a095"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M179.8,180.5c9.211,5.7,16.389,18.979,16.034,29.669s-8.111,14.735-17.321,9.039-16.389-18.979-16.034-29.668S170.59,174.8,179.8,180.5Z",
    transform: "translate(-158.588 -168.878)",
    fill: "#e8dfd1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M162.511,190.37c0-.133,0-.261.012-.39.355-10.7,7.3-15.472,16.128-11.875a22.283,22.283,0,0,1,3.339,1.717c5.895,3.644,11.048,10.053,14.317,17.115a36.742,36.742,0,0,1,3.7,16.233c-.4,12.016-9.117,16.564-19.467,10.159l-2.032-1.237c9.211,5.7,16.966,1.65,17.321-9.039a32.742,32.742,0,0,0-3.293-14.442c-2.914-6.285-7.5-11.984-12.741-15.226a20.159,20.159,0,0,0-2.973-1.529c-7.849-3.2-14.029,1.053-14.349,10.568l-.008.343Z",
    transform: "translate(-158.584 -171.763)",
    fill: "#c6c0b3"
  })))))))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M771.413,387.368c-11.82-3.64-3.967-24.687-3.967-24.687l-2.735-5.259a14.638,14.638,0,0,0-5.325-6.39L647.808,269.981Q572.934,339.2,465.185,376.261L439.773,280.2c-3.062-5.938-7.533-10.935-12.281-13.677L185.2,127.186c-3.074-1.775-5.731-.843-6.4,2.22l-.016,2.239.737,1.084,89.938,52.225-9.612,70.885L152.677,194.306c.012-.027-3.893,1.845-3.893,1.845l-4.834,6.507-.207,87,9.347,17.856L184,325.362c1.092-28.046,21.675-39.145,46.822-24.628s45.64,49.334,46.529,78.527L482.265,498.037c1.053-28.069,21.671-39.148,46.822-24.628,15.667,9.043,29.512,25.962,37.951,44.5,5.107,11.212,8.228,23.013,8.579,34.026,0,0,25.8-18.6,30.125-20.766,9.043-4.522,111.531-38.364,168.524-96.9l1.572-39.226C775.837,391.2,773.332,387.957,771.413,387.368ZM267.68,264.356l10.12-74.606,86.08,49.6-10.061,74.193Zm94.479,53.93,10.057-74.142,52.908,30.429,24.09,93.262Z",
    transform: "translate(-136.742 -39.389)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(7.001 204.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M143.852,156.5l-.109,45.519,9.347,17.856L184,237.72c1.092-28.046,21.675-39.145,46.822-24.628s45.64,49.334,46.529,78.527L482.265,410.394c.987-26.31,19.171-37.693,42.156-27.059Z",
    transform: "translate(-143.743 -156.501)",
    fill: "#6ba07f",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M241.323,214.646l16.5,11.044a74.349,74.349,0,0,0-11.836-8.614Q243.625,215.713,241.323,214.646Z",
    transform: "translate(139.355 12.188)",
    fill: "#6ba07f",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M367.332,147.254a5.02,5.02,0,0,0-6.737-1.623l-137.072,79.44a5.024,5.024,0,0,0-2.294,5.774l27.351,89.208c64.725-24.433,127.932-60.5,170.794-98.961ZM225.969,230.029a1.923,1.923,0,0,1,.878-2.212l134.5-77.954a1.917,1.917,0,0,1,.968-.261,1.886,1.886,0,0,1,1.607.882l48.043,67.022c-39.78,35.189-99.172,69.586-160.908,93.219Z",
    transform: "translate(87.455 14.752)",
    fill: "#302c26"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M408.761,163.124c-46.6,44.594-108.141,79.592-182.622,106.28l128.837,70.44c21.047,13.966,172.312-76.912,158.966-91.951Z",
    transform: "translate(102.304 67.469)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(123.307 142.703)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M343.457,229.815,187.468,140.6,174.43,228.161l-.874,13.553.055,22.369.277.332c16.947,20.029,23.68,42.262,21.2,69.948l-.074.737,170.314,99.465,9.4-92.595.027-.222ZM268.32,375.376,197.5,333.829c2.341-27.866-4.51-50.333-21.531-70.612l-.055-21.429.866-13.377,12.46-84.059,92.79,52.974-.3-.043-12.706,84.578-.874,15.917Zm95.033,55.3L270.688,376.73l-.176-78.89.866-15.737,12.577-83.68L341.892,231.5,372.36,341.951Z",
    transform: "translate(-173.556 -140.595)",
    fill: "#649f78"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(438.759 323.867)"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M327.579,187.325a.69.69,0,0,1,.948-.168c5.91,4.436,4.771,29.489,1.326,33.96a237.393,237.393,0,0,1-27.5,22.748,4.256,4.256,0,0,1-6.714-3.3c-.242-5.785-.523-13.674-.558-19.373a12.4,12.4,0,0,1,5.352-10.315C307.566,205.933,320.448,196.387,327.579,187.325Z",
    transform: "translate(-136.45 -187.033)",
    fill: "#ecedef"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M262,251.107a48.016,48.016,0,0,0,24.5-.862c11.551-3.624,27.71-11.036,35.169-14.567a4.8,4.8,0,0,0,2.423-6.14c-1.689-4.3-4.346-11.079-6.339-16.3a7.336,7.336,0,0,0-9.734-4.116q-8.614,3.575-17.411,6.7c-5.6,1.982-11.746,4.67-17.75,5.032a35.735,35.735,0,0,1-10.7-1.818C251.612,220.959,257.772,250.117,262,251.107Z",
    transform: "translate(-248.879 -124.636)",
    fill: "#ecedef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M274.051,213.021a2.018,2.018,0,0,1-.222.031,35.738,35.738,0,0,1-10.7-1.818c-.5-.183-13.272,9.5-3.425,31.1a46.2,46.2,0,0,0,17.462,1.962C274.047,233.876,272.767,222.871,274.051,213.021Z",
    transform: "translate(-249.858 -116.83)",
    fill: "#ecedef",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M267.69,211.469a4.912,4.912,0,0,0-5.364,1.248l-5.4,5.914a9.573,9.573,0,0,0-2.111,9.207,56.162,56.162,0,0,0,4.853,12.082c.714,1.194,3.741,2.618,8.009,3.609C262.428,230.679,267.69,211.469,267.69,211.469Z",
    transform: "translate(-254.416 -117.066)",
    fill: "#d16a0d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M365.825,239.356l52.908,30.429,24.09,93.262L355.767,313.5ZM261.289,259.568l86.138,49.182,10.061-74.193-86.08-49.6Zm1.787-79.4-89.942-52.225-27.187,61.377,107,65.5Z",
    transform: "translate(-130.351 -34.601)",
    fill: "#af955a",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M256.1,205.408l-.511,3.766L145.035,145.717l3.554-2.042Z",
    transform: "translate(-132.995 11.044)",
    fill: "#8bcca2"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(130.939 150.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M175.512,217.164l4.328-1.573,9.608-70.839-3.816-2.194Z",
    transform: "translate(-175.512 -142.558)",
    fill: "#649f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M209.786,156.5,199.73,230.644l4.328-1.574L213.6,158.7Z",
    transform: "translate(-105.25 -102.107)",
    fill: "#649f78"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(130.939 223.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M175.512,162.852l86.137,49.182.509-3.747L179.84,161.278Z",
    transform: "translate(-175.512 -161.278)",
    fill: "#8bcca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M285.562,221.492l-81.5-46.39-4.328,1.574,87.055,49.549Z",
    transform: "translate(-105.25 -121.172)",
    fill: "#8bcca2"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M332.238,310.852l-6.624-3.226c-.008-.25-.059-.7-.07-.956-.562-12.932-4.635-25.7-10.635-37.533-27.055-53.329-80.189-63.753-82.588-16.323a.577.577,0,0,1-.7-.417c-14.536-54.542,68.013-61.416,93.16,13.483C326.028,269.378,332.32,310.9,332.238,310.852Z",
    transform: "translate(113.26 205.105)",
    fill: "#7bb48f"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M153.709,200.4c.035,1,1.256,7.88,2.243,8.021,5.7-63.979,90.348-15.656,93.215,53.844.6.14.737-.191.909-.632,2.091-5.3,3.441-16,1.6-27.2C239.539,155.645,147.748,146.579,153.709,200.4Z",
    transform: "translate(-108.636 76.886)",
    fill: "#7bb48f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M258.312,299.511s22.073,10.33,40.073,6.492c40.065-8.54,152.326-79.366,162.882-90.878l.691-18.784s7.919,9.788,9.429,17.309l-6.21,40.717a7.9,7.9,0,0,1-1.857,5.313c-17.3,19.362-138.972,87.336-164.349,94.416-7.779,2.173-19.03,4.28-33.207-3.343-1.322-21.2-6.772-36.343-13.943-46.518l4.354-1.525Z",
    transform: "translate(176.81 163.834)",
    fill: "#7bb48f"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M461.957,196.34l-.691,18.784C450.71,226.637,338.45,297.463,298.385,306c-18,3.839-40.073-6.492-40.073-6.492l-6.492,4.724c3.975,4.619,31.514,16.424,51.578,10.522,50.961-14.988,124.538-64.007,145.955-78.683,21.242-14.555,22.034-22.424,22.034-22.424C469.877,206.128,461.957,196.34,461.957,196.34Z",
    transform: "translate(176.81 163.834)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(263.083 309.817)",
    style: {
      isolation: "isolate"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M236.756,183.7a2.782,2.782,0,0,0-2.813.269L213.4,196.014a8.749,8.749,0,0,0-3.956,6.882l-.062,10.518a2.8,2.8,0,0,0,1.17,2.571l2.036,1.186a2.8,2.8,0,0,1-1.166-2.571l.062-10.518a8.75,8.75,0,0,1,3.956-6.882l20.54-12.043a2.782,2.782,0,0,1,2.813-.269Z",
    transform: "translate(-209.385 -183.432)",
    fill: "#494443"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(2.04 1.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M234.466,184.275c2.185-1.26,3.975-.238,3.983,2.3l-.066,10.522a8.756,8.756,0,0,1-3.952,6.882l-20.544,12.043c-2.181,1.26-3.971.238-3.979-2.3l.062-10.518a8.75,8.75,0,0,1,3.956-6.882Z",
    transform: "translate(-209.908 -183.736)",
    fill: "#383534"
  })))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M242.954,192.363c-11.731,10.03-24.929-3.441-25.463-4.073-1.681-1.974-5.516,1.272-3.312,3.363,4.108,3.905,11.8,9.074,20.017,9.074,4.26,0,9.023-.589,13.038-4.229C249.5,194.438,245.556,190.143,242.954,192.363Z",
    transform: "translate(65.675 138.701)",
    fill: "#302c26"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M149.07,167.94,198.3,196.922a57.182,57.182,0,0,0-5.766,5.93c-6.008,8.415-7.264,21.932-3.332,30.94,0,0-31.315-17.173-39.933-23.38a6.313,6.313,0,0,1-2.559-4.073c-1.7-9.207-4.627-35.739-4.763-40.073-.148-4.576,7.12-8.411,7.12-8.411Z",
    transform: "translate(-141.948 52.182)",
    fill: "#7bb48f"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M192.537,202.851a57.182,57.182,0,0,1,5.766-5.93L149.07,167.94V157.855s-7.268,3.835-7.12,8.411c.031,1.1.25,3.652.581,6.971C143.64,174.349,191.855,203.815,192.537,202.851Z",
    transform: "translate(-141.948 52.182)",
    fill: "#89cea5"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(224.676 301.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(3.534 2.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M209.036,197.028l-5.294-3.058a6.84,6.84,0,0,1-3.3-5.2v-6.7c0-1.822,11.887,5.04,11.887,6.858v6.7C212.333,197.453,210.854,198.077,209.036,197.028Z",
    transform: "translate(-200.446 -181.77)",
    fill: "#649f78"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M215.882,194.736l-13.728-7.923a5.425,5.425,0,0,1-2.614-4.124c0-1.447,1.17-1.943,2.614-1.108l13.728,7.927a5.418,5.418,0,0,1,2.614,4.124C218.5,195.076,217.326,195.571,215.882,194.736Z",
    transform: "translate(-199.54 -181.176)",
    fill: "#e8dfd1"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(130.146 246.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(3.534 2.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M184.805,183.079l-5.294-3.055a6.836,6.836,0,0,1-3.3-5.2v-6.7c0-1.818,11.883,5.04,11.883,6.862v6.7C188.1,183.508,186.623,184.129,184.805,183.079Z",
    transform: "translate(-176.215 -167.822)",
    fill: "#649f78"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M191.651,180.789l-13.728-7.927a5.425,5.425,0,0,1-2.614-4.124c0-1.443,1.17-1.939,2.614-1.1l13.728,7.923a5.425,5.425,0,0,1,2.614,4.124C194.265,181.129,193.094,181.62,191.651,180.789Z",
    transform: "translate(-175.309 -167.229)",
    fill: "#e8dfd1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(4.319 176.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M143.767,176.23l9.066,5.239a1.679,1.679,0,0,0,1.736,0,1.728,1.728,0,0,0,.878-1.506V158.5a5.549,5.549,0,0,0-2.657-4.717l-2.836-1.717a5.564,5.564,0,0,1-5.508,4.19H144c-.074,0-.121-.035-.191-.039Z",
    transform: "translate(-140.991 -141.076)",
    fill: "#acaba9",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M156.111,164.847a4.074,4.074,0,0,0-1.97-3.484l-8.2-4.958v-7.159A2.755,2.755,0,0,0,143.163,152s-.32,21.269.144,26.384a4.677,4.677,0,0,0,2.38,3.687l10.424,6.02Z",
    transform: "translate(-143.055 -149.246)",
    fill: "#9e081e"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M526.361,239.92c-19.5-3.168-34.99-8.727-42.765-13.213L283.157,110.982c-7.775-4.49,1.615-5.594,21.117-2.43l5.13,6.062c-10.178-.909-14.118.359-8.684,3.5L481.942,221.932c6.511,3.761,22.6,8.774,39.047,11.743ZM395.554,306.1c-16.447-2.973-32.536-7.986-39.047-11.746L175.285,190.531c-5.434-3.14-1.494-4.408,8.688-3.5l-5.134-6.059c-19.5-3.168-28.892-2.064-21.117,2.426L358.161,299.125c7.775,4.49,23.267,10.049,42.769,13.213Z",
    transform: "translate(-104.106 -96.098)",
    fill: "#649f78",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(68.101 72.703)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(11.875 10.32)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    style: {
      isolation: "isolate"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M166.046,126.967l2.867-1.67c-1.947,1.131-3.254,3.371-3.593,6.5l-2.871,1.666c.343-3.133,1.65-5.368,3.6-6.5Z",
    transform: "translate(-162.449 -125.297)",
    fill: "#c6c0b3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(4.088)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    style: {
      isolation: "isolate"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M373.766,240.309,173.327,124.588c-3.917-2.263-7.451-2.473-10-.991l-2.871,1.666c2.551-1.482,6.09-1.268,10,.991L370.895,241.979a25.04,25.04,0,0,1,6.187,5.208l2.871-1.666A25.131,25.131,0,0,0,373.766,240.309Z",
    transform: "translate(-160.453 -122.652)",
    fill: "#e8dfd1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M224.3,162.714a33.859,33.859,0,0,0-5.45-8.567l-2.871,1.666a33.945,33.945,0,0,1,5.454,8.567,26.44,26.44,0,0,1,2.423,10.51l2.867-1.666A26.339,26.339,0,0,0,224.3,162.714Z",
    transform: "translate(0.647 -31.278)",
    fill: "#c6c0b3"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(0 1.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M373.935,240.739c7.779,4.49,14.087,15.347,14.06,24.285L376.12,258.17c-.7-7.623-5.992-16.3-12.5-20.056L183.8,134.291c-6.511-3.757-11.77-1.174-12.515,5.61L159.4,133.047c.027-8.938,6.316-12.523,14.091-8.033Z",
    transform: "translate(-159.405 -123.079)",
    fill: "#a5a095"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(193.661 0.208)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(11.875 10.323)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    style: {
      isolation: "isolate"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M198.231,108.385l2.871-1.67c-1.947,1.131-3.254,3.371-3.6,6.5l-2.871,1.67c.347-3.133,1.65-5.368,3.6-6.5Z",
    transform: "translate(-194.634 -106.715)",
    fill: "#c6c0b3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(4.092)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    style: {
      isolation: "isolate"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M405.948,221.733,205.509,106c-3.913-2.259-7.447-2.473-10-.991l-2.867,1.67c2.551-1.482,6.09-1.268,10,.991L403.081,223.4a25.1,25.1,0,0,1,6.187,5.208l2.867-1.666A24.96,24.96,0,0,0,405.948,221.733Z",
    transform: "translate(-192.639 -104.069)",
    fill: "#e8dfd1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M256.489,144.132a33.7,33.7,0,0,0-5.454-8.567l-2.867,1.666a33.925,33.925,0,0,1,5.45,8.571,26.376,26.376,0,0,1,2.423,10.506l2.871-1.67A26.3,26.3,0,0,0,256.489,144.132Z",
    transform: "translate(-31.539 -12.693)",
    fill: "#c6c0b3"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(0 1.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M406.124,222.157c7.775,4.49,14.083,15.347,14.06,24.285l-11.871-6.858c-.706-7.623-6-16.3-12.507-20.056L215.98,115.71c-6.507-3.761-11.77-1.178-12.515,5.61l-11.875-6.858c.027-8.934,6.316-12.519,14.095-8.029Z",
    transform: "translate(-191.59 -104.497)",
    fill: "#a5a095"
  })))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M348.266,196.168c-18.441,16.5-60.051,37.428-72.745,43.631a4.409,4.409,0,0,0-2.107,5.692L287.708,279.3a3.684,3.684,0,0,0,5.239,1.755l60.433-34.892a5.715,5.715,0,0,0,2.844-5.446L352.546,197.9A2.571,2.571,0,0,0,348.266,196.168Z",
    transform: "translate(238.432 161.416)",
    fill: "#383534"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M272.481,169s5.645,3.5,13.947,8.969c4.1,2.809,8.973,5.957,14.033,9.558,5.072,3.585,10.478,7.412,15.886,11.235,5.317,3.948,10.639,7.888,15.624,11.59s9.511,7.334,13.455,10.354c7.787,6.183,12.87,10.451,12.87,10.451-.109.156-85.924-62-85.924-62Z",
    transform: "translate(236.435 84.513)",
    fill: "#d3fccf"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M235.726,190.208l99.309,54.371c-.09.168-6.527-2.813-16.045-7.529-4.72-2.43-10.3-5.134-16.143-8.27s-12.094-6.46-18.336-9.8c-6.172-3.46-12.343-6.925-18.129-10.171s-11.075-6.476-15.667-9.14c-9.1-5.481-15.078-9.293-15.078-9.293Z",
    transform: "translate(129.857 146.044)",
    opacity: 0.5,
    fill: "url(#linear-gradient-16)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M234.047,181.559l19.541,2.852a11.48,11.48,0,0,0,7.229-1.307c5.1-2.817,14.715-8.27,20.43-12.347a8.153,8.153,0,0,0,3.406-6.347l.562-12.987C267.258,164.074,264.129,166.118,234.047,181.559Z",
    transform: "translate(125.247 33.519)",
    fill: "#302c26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(137.345 88.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(113.639 65.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M216.143,253.655A73.513,73.513,0,1,0,243.05,153.234,73.518,73.518,0,0,0,216.143,253.655Z",
    transform: "translate(-206.284 -143.375)",
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(43.55 41.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M243.044,179.193c-12.967-3.636-23.551-5.906-23.551-5.906s10.209,3.6,23.165,7.28c-3.636,12.971-5.906,23.555-5.906,23.555s3.6-10.209,7.28-23.165c12.968,3.636,23.552,5.906,23.552,5.906s-10.209-3.6-23.161-7.284c3.632-12.968,5.9-23.551,5.9-23.551S246.727,166.237,243.044,179.193Z",
    transform: "translate(-211.511 -148.132)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M277.471,170.4a32.051,32.051,0,1,1-43.623-12.312A32.054,32.054,0,0,1,277.471,170.4Z",
    transform: "translate(-217.447 -154.004)",
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(332.037 289.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M287.866,226.129c-12.968-3.636-23.555-5.9-23.555-5.9s10.213,3.6,23.169,7.276c-3.64,12.971-5.906,23.555-5.906,23.555s3.6-10.209,7.28-23.165c12.972,3.636,23.555,5.906,23.555,5.906s-10.213-3.6-23.165-7.28c3.636-12.971,5.9-23.555,5.9-23.555S291.549,213.173,287.866,226.129Z",
    transform: "translate(-256.333 -195.068)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M322.286,217.341a32.05,32.05,0,1,1-43.619-12.312A32.05,32.05,0,0,1,322.286,217.341Z",
    transform: "translate(-262.266 -200.94)",
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(254.287 49.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M267.934,164.515c-12.968-3.636-23.552-5.906-23.552-5.906s10.209,3.6,23.161,7.284c-3.632,12.968-5.9,23.551-5.9,23.551s3.593-10.209,7.28-23.165c12.964,3.636,23.551,5.906,23.551,5.906s-10.209-3.6-23.169-7.28c3.64-12.968,5.906-23.555,5.906-23.555S271.616,151.559,267.934,164.515Z",
    transform: "translate(-236.401 -133.454)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M302.359,155.727a32.05,32.05,0,1,1-43.623-12.312A32.049,32.049,0,0,1,302.359,155.727Z",
    transform: "translate(-242.336 -139.326)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(243.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M265.2,151.852c-12.968-3.636-23.552-5.906-23.552-5.906s10.213,3.6,23.165,7.28c-3.636,12.971-5.906,23.555-5.906,23.555s3.6-10.209,7.28-23.165c12.971,3.636,23.551,5.906,23.551,5.906s-10.205-3.6-23.161-7.28c3.636-12.971,5.906-23.555,5.906-23.555S268.884,138.9,265.2,151.852Z",
    transform: "translate(-233.669 -120.791)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M299.627,143.064a32.051,32.051,0,1,1-43.619-12.312A32.048,32.048,0,0,1,299.627,143.064Z",
    transform: "translate(-239.604 -126.663)",
    fill: "url(#radial-gradient-5)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(0 4.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M202.752,153.006c-12.968-3.632-23.552-5.9-23.552-5.9s10.209,3.6,23.165,7.28c-3.636,12.968-5.906,23.551-5.906,23.551s3.6-10.209,7.283-23.165c12.964,3.636,23.551,5.906,23.551,5.906s-10.209-3.6-23.165-7.28c3.636-12.968,5.9-23.555,5.9-23.555S206.434,140.05,202.752,153.006Z",
    transform: "translate(-171.219 -121.946)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M237.177,144.217a32.049,32.049,0,1,1-43.623-12.308A32.054,32.054,0,0,1,237.177,144.217Z",
    transform: "translate(-177.154 -127.817)",
    fill: "url(#radial-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(445.971 199.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M317.073,202.906c-12.971-3.636-23.556-5.9-23.556-5.9s10.21,3.6,23.165,7.28c-3.64,12.967-5.906,23.551-5.906,23.551s3.6-10.209,7.284-23.165c12.967,3.636,23.551,5.906,23.551,5.906s-10.213-3.6-23.165-7.28c3.636-12.968,5.9-23.555,5.9-23.555S320.751,189.95,317.073,202.906Z",
    transform: "translate(-285.535 -171.845)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M351.491,194.118a32.049,32.049,0,1,1-43.615-12.312A32.044,32.044,0,0,1,351.491,194.118Z",
    transform: "translate(-291.471 -177.717)",
    fill: "url(#radial-gradient-7)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(539.344 103.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(0 35.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M284.142,180.359c-7.557-4.3-11.321,2.789-23.025-11.411a11.934,11.934,0,0,1-2.411-3.843c-1.131-3.57.375-11.973,11.388-10.186,3.73.6,8.068-.765,11.446.211,1.17.339,2.267.893,3.417,1.287,3.441,1.167,8.661,1.143,10.178,4.615.566,1.3-.125,2.832.379,4.19,1.33,3.57,7.83,4.042,6.632,9.059-.628,2.629-.566,5.064-3.055,6.691-2.138,1.393-5.255,1.713-7.724,1.88C287.3,183.125,287.333,182.177,284.142,180.359Z",
    transform: "translate(-258.391 -96.119)",
    fill: "#ffeb51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M333.56,146.333c-4.5,6.925-11.349,16.377-11.625,16.841-2,1.518-9.9,4.092-13.5,6.386L285.521,183.5c-6.234-1.482-9.714-.7-14.938-2.079a48.729,48.729,0,0,0-5.263-.909c-.753-.117-1.592.928-.324,1.549.386.187,7.627,2.091,7.693,2.419,0,0-9.886-1.381-10.424-1.482-1.56-.3-1.151,1.658-.425,1.943.889.351,9.655,1.7,10.56,1.861,1.389.172,1.568.827.975.9-1.557-.016-8.528.109-8.965.133-2.149.121-.55,2.544,1.112,2.407.975-.078,8.446-.312,9.464-.187a2.75,2.75,0,0,1,1.046.308c.636.367.57.8.32,1.018-.726.628-3.78.979-5.364,1.592-1.33.515-.055,1.662.133,1.8.648.472,1.576.562,3.394.183,1.346-.281,3.039-.878,4.4-1.143a18.548,18.548,0,0,1,6.893.1c1.373.433.152,2.321-.269,3-1.475,2.364,1.49,4.506,2.875,3.421,1.237-.971,2.626-1.853,2.824-3.336s3.285-3.523,3.7-4.818c7.061-2.407,19.4-6.6,23.5-7.923,5.641-1.822,12.316-6.558,15.757-9.183.714-.25,9.722-11.274,12.375-14.856.566-.761,1.116-1.537,1.67-2.31A60.047,60.047,0,0,1,333.56,146.333Z",
    transform: "translate(-250.255 -120.314)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M279.106,168.16c4.354-7.365,9.429-16.3,15.581-22.245,2.789-2.692,6-5.157,9.78-6.008s7.7.624,9.394,3.082c.983,1.42,4.174,7.3,4.272,9.02.339,6.027-15.148,20.719-19.077,26.337C295.467,183.468,277.194,171.39,279.106,168.16Z",
    transform: "translate(-198.7 -139.664)",
    fill: "#ffd940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(92.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(10.286 4.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M292.385,141.26c1.576-1.97,28.658,7.752,27.476,9.62,0,0-5.583,21.172-23.856,15.164C278.209,160.192,292.385,141.26,292.385,141.26Z",
    transform: "translate(-277.735 -104.893)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M308.574,138.994s-2.606,5.906,2.119,14.6c4.763,8.774-10.529,18.905-18,13.592a14.129,14.129,0,0,1-2.36-2.13A9.644,9.644,0,0,1,288,158.726c-.055-5.633-.238-12.3-.238-12.3Z",
    transform: "translate(-275.627 -110.706)",
    fill: "#f3a984"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M320.863,158.706c-2.981,9.851-16.564,21.5-28.471,23.879a4.895,4.895,0,0,1-3.773-.663c-3.062-2.153-3.784-7.248-3.956-14.813a85.762,85.762,0,0,1,1.459-17.224,22.75,22.75,0,0,1,13.116-16.56,13.567,13.567,0,0,1,3.269-1.007c5.22-.757,10.978.484,13.674,2.61C319.482,137.53,325.494,143.4,320.863,158.706Z",
    transform: "translate(-284.651 -130.722)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M317.611,165.094a20.537,20.537,0,0,0,2.59-4.439c1.908-4.81,3.433-10.092,2.165-15.109a22.517,22.517,0,0,0-2.821-6.261,20.51,20.51,0,0,0-16.424-7.541c-8.438,0-18.675,6.749-17.871,16.354,0,0,2.7,2.317,14.15,6.445,5.9,2.126,6.823,3.125,4.362,9.035-.811,1.954,2.185,3.039,3.062,1.2.726-1.514,5.072-5.575,8.477-4.19C316.968,161.263,315.93,166.647,317.611,165.094Z",
    transform: "translate(-283.038 -131.743)",
    fill: "#4f321f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M299.557,139.449c2.852,1.381,2.672,5.594-2.719,10.26-.808.7-4.49,3.343-5.438,2.871-1.982-.983,1.081-8.454,2.231-10.346C294.926,140.1,297.107,138.26,299.557,139.449Z",
    transform: "translate(-266.961 -110.471)",
    fill: "#fcbe9f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M305.817,162.209c-5.434.078-20.871-6.211-21.164-13.7,0,0,4.307-23.778,29-16.584,15.846,5.493,10.911,23.52,10.911,23.52C323.809,158.214,310.483,162.147,305.817,162.209Z",
    transform: "translate(-274.357 -130.568)",
    fill: "#ffd940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M282.619,141.974c3.78,1.061,7.947,3.577,12.281,7.33a14.171,14.171,0,0,0,12.769,2.934c3.4-.854,7.525-2.083,11.875-3.628-6.082.32-28.725-6.87-26.989-13.693C292.555,134.917,279.034,140.964,282.619,141.974Z",
    transform: "translate(-282.014 -117.953)",
    fill: "#fff643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M289.953,131.931c-.109.687,1,1.432,2.481,1.666s2.762-.133,2.867-.819-1-1.432-2.473-1.666S290.067,131.244,289.953,131.931Z",
    transform: "translate(-259.001 -129.194)",
    fill: "#fff643"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(51.007 153.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(162.734 117.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M319.25,175.976l-2.737,32.356-141.584-23.8.137-2.225Z",
    transform: "translate(-174.929 -166.355)",
    fill: "url(#linear-gradient-17)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M320.065,173.51l-4.355,51.473-140.782-33.3.137-2.225Z",
    transform: "translate(-174.929 -173.51)",
    fill: "url(#linear-gradient-18)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M318.65,177.766l-1.585,18.721L174.937,179.006l.078-1.287Z",
    transform: "translate(-174.906 -161.3)",
    fill: "url(#linear-gradient-19)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M318.137,183.307l-.6,7.064-142.6-12.066.03-.484Z",
    transform: "translate(-174.889 -161.001)",
    fill: "url(#linear-gradient-20)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M176.959,232.246a8.522,8.522,0,0,0,.636,2.235c.129.293.234.562.359.847a11.487,11.487,0,0,1,5.138-.207,126.489,126.489,0,0,0,12.632,1.681s-5.5-6.85-2.805-6.835c1.358.008,2.719.043,4.081.09,5.294.172,4.771-3.074,2.77-3.027a50.615,50.615,0,0,1-5.883-.488c-2.891-.254-4.724-2.282-7.408-2.969a6.407,6.407,0,0,0-.827-.121c-3.437-8.458-16.346-36.542-16.346-36.542.437-8.547,1.857-20.072,2.111-27.464a1.481,1.481,0,0,0-2.785-.745c-5.255,9.7-16.459,30.956-14.914,33.063.1,2.715,15.831,27.371,21.636,35.992A10.739,10.739,0,0,1,176.959,232.246Z",
    transform: "translate(-74.158 -101.483)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(0 132.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(78.165 127.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M199.6,226.85c-1.584-2.622-7.611-4.826-13.471-7.167-5.941-2.368-14.3-5.9-14.665-6.745-.3-.7-.152-1.592-.675-2.146a2.166,2.166,0,0,0-1.225-.523,20.263,20.263,0,0,0-12.429,1.7c-1.775.866-3.843,4.455-3.843,4.455.176,2.235-.16,9.577.324,10.475,0,0,8.879,3.6,9.32,3.765.846.316,1.131-.741,1.861-.78,6.546,3.351,14.863,6.152,18.679,6.675,4.381.6,14.177,2.271,16.518-2.809A7.584,7.584,0,0,0,199.6,226.85Z",
    transform: "translate(-153.141 -209.945)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(0 13.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M200.1,221.63c-2.341,5.079-12.137,3.406-16.518,2.809-3.815-.523-30.242-11.126-30.242-11.126-.254,2.723.082,3.71.382,4.256,0,0,8.879,3.6,9.32,3.768.846.316,1.131-.741,1.861-.784,6.546,3.351,14.863,6.152,18.679,6.675,4.381.6,14.493,2.271,16.834-2.809a6.469,6.469,0,0,0,.257-4.568A9.18,9.18,0,0,1,200.1,221.63Z",
    transform: "translate(-153.251 -213.313)",
    fill: "#e58d2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(0.132 143.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M140.742,253.931c5.836,4.791,14.407,3.585,17.392.858,4.268-3.9-3.129-15.121-3.936-28.561-.047-.8.386-7.268.051-7.463-4.728-2.754-16.728-7.225-19.931-3.16-1.186,1.5-.8,7.077-.862,8.879C133.06,235.97,132.459,247.139,140.742,253.931Z",
    transform: "translate(-133.215 -213.972)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M158.865,249.751c-2.984,2.727-11.555,3.928-17.4-.862-8.278-6.792-7.674-17.957-7.284-29.442.031-.952-.055-2.941.027-4.838-1.057,1.689-.714,6.952-.772,8.7-.39,11.485-.995,22.65,7.283,29.446,5.84,4.787,14.411,3.585,17.4.854a5.559,5.559,0,0,0,1.365-4.67A5.553,5.553,0,0,1,158.865,249.751Z",
    transform: "translate(-133.249 -212.125)",
    fill: "#e58d2e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M155.168,203.481c-1.322,14.005-2.977,27.78-3.847,39.3a41.3,41.3,0,0,1-.878,6.753,51.153,51.153,0,0,1-2.352,6.632c-6.722,17.009-12.1,48.347-14.844,66.312-.964,6.308,20.04,9.85,21.956,2.469.62-2.4,10.147-43.194,15.152-54.125,2.649-5.774,6.562-10.9,9.051-16.744A87.667,87.667,0,0,0,183.3,241.1a296.654,296.654,0,0,1,12.152-37.487c1.607-4.026,3.32-8.11,3.57-12.433l-38.278-13.494C158.706,182.508,155.718,194.52,155.168,203.481Z",
    transform: "translate(-133.215 -176.219)",
    fill: "#211921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M154.035,240.353c.421,2.606.71,12.183,3.023,22.639,4.311,19.483,11.715,44.275,12.41,48.585.979,6.1,23.832,2.329,22.639-4.4,0,0-8.134-69.667-8.22-70.736-.207-2.6-.417-5.2-.425-7.814-.008-3.441-.269-7.877-.5-11.31C182,202.633,181.394,189.209,180,177.31c-10.763.48-32.548,18.757-33.148,25.463-.281,3.117,1.155,5.981,1.759,9C150.555,221.429,152.451,230.628,154.035,240.353Z",
    transform: "translate(-93.764 -177.31)",
    fill: "#211921"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M172.17,157.3c-6.652,2.048-13.557,3.7-19.955,6.386-6.546,2.75-11.723,8.333-12.987,15.316-1.323,7.3-.374,17.59,4.771,31.857a80.624,80.624,0,0,1,3.733,18.656,51.285,51.285,0,0,1-.722,13.592,45.593,45.593,0,0,1-2.844,9.925c-6.3,13.17,20.364,19.065,34.03,17.138,12.663-1.783,26.466-5.38,26.076-18.207-.417-13.658-1.432-27.523,1.7-40.818,1.674-7.1,4.506-13.912,5.766-21.09a99.674,99.674,0,0,0,1.116-12.987l.4-9.6a14.949,14.949,0,0,0-14.052-15.46C190.162,151.507,180.679,154.682,172.17,157.3Z",
    transform: "translate(-117.326 -118.793)",
    fill: "#ffd940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M157.585,151.957c-15.062,0,9.41,28.74,9.41,28.74l-.176,4.17s9.827-.6,9.585-5.185C175.811,168.412,172.651,151.957,157.585,151.957Z",
    transform: "translate(-76.728 -118.783)",
    fill: "#ffd940"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(43.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M172.714,152.158c-7.3,2.785-14.75,4.085-26.739,8.427a2.522,2.522,0,0,0-1.268,3.71c5.356,8.446,14.329,17.657,24,13.966l.234-.09a14.119,14.119,0,0,0,8.528-17.274C176.288,157.112,174.485,155.271,172.714,152.158Z",
    transform: "translate(-144.32 -118.199)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M156.323,150.027,145.712,168.1s-.082,2.614,3.214,6.987c5.079,6.741,10.338,7.444,13.65,7.007a5.692,5.692,0,0,0,4.627-3.909l.663-2.04Z",
    transform: "translate(-140.28 -124.382)",
    fill: "#f3a984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M158.936,145.325c-7.884,3.066-13.7,8.672-11.848,23.778,1.428,11.618,11.2,23.364,19.912,29.672,2.153,1.564,8.77,3.238,10.9-1.775,1.8-4.252,6.066-16.689,6.16-27.515.078-8.7-.246-16.166-6.89-21.519C172.613,144.3,167.183,142.11,158.936,145.325Z",
    transform: "translate(-137.294 -142.548)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M161.271,175.691c1.884-11.122,15.769-3.425,23.294-10.947,1.362-4.6-.632-11.766-6.815-16.9-4.5-3.733-10.646-6.1-18.9-2.887-7.88,3.07-14.087,9.281-11.852,25.046.164,1.163,1.939,10.26,4.065,10.26,1.342-.308.339-5.146.554-6.5.359-2.243,2.813-3.445,4.451-1.681a5.364,5.364,0,0,1,1.42,2.848c.156.991-.261,2.1.3,3C158.716,179.382,160.682,179.187,161.271,175.691Z",
    transform: "translate(-137.878 -143.453)",
    fill: "#4f321f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(41.147 147.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M145.474,356.69a1.707,1.707,0,0,1-1.053-3.055c17.13-13.4,14.77-45.187,13.5-62.271-.23-3.1-.421-5.676-.441-7.51-.125-10.17-2.048-20.575-3.913-30.636-2.965-16.026-6.035-32.6-1.9-48.683A51.347,51.347,0,0,1,164.426,181.7a1.709,1.709,0,0,1,2.458,2.376,47.937,47.937,0,0,0-11.9,21.312c-3.948,15.351-1.081,30.827,1.951,47.208,1.888,10.206,3.843,20.754,3.967,31.217.023,1.783.207,4.283.433,7.3,1.315,17.719,3.761,50.7-14.805,65.216A1.7,1.7,0,0,1,145.474,356.69Z",
    transform: "translate(-143.762 -181.176)",
    fill: "#3d3838"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M174.309,176.473c-2.161.726-5.981,3.932-8.274,5.586-4.307,3.1-8.384,6.027-12.4,9.492a54.453,54.453,0,0,0-5.325,4.986,2.238,2.238,0,0,0,.265,3.176,54.51,54.51,0,0,0,6.57,4.6,10.637,10.637,0,0,0,6.866,1.51,29.086,29.086,0,0,0,6.566-1.615c7.994-3.1,20.1-15.242,25.877-21.531C194.926,182.165,176.817,175.627,174.309,176.473Zm-2.438,20.3c-2.7,1.716-6.156,4.077-9.324,4.514-2.095.289-5.754-2.036-5.746-2.333.043-.944,19.8-15.769,19.8-15.769s10.463.367,10.334.663C186.937,183.85,175.854,194.243,171.87,196.775Z",
    transform: "translate(-90.994 -47.876)",
    fill: "#262323"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(10.801 43.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M206.96,223.7c-7.3,5.594-13.877,1.678-12.823-.4a2.3,2.3,0,0,1,.917-.8,4.631,4.631,0,0,0,1.795-6.226,1.314,1.314,0,0,0-.46-.507,1.091,1.091,0,0,0-1.19.226c-.612.523-.722,1.182-1.124,1.81a4.122,4.122,0,0,1-2,1.381,13.705,13.705,0,0,1-6.558.917c-23.477-9.737-32.068-16.678-32.068-16.678,4.057-12.129,11.981-32.528,9.183-36.964-1.042-1.646-5.43-2.918-7.654-3.027l-15.215,1.178c.18,1.728-1.81,14.5-2.926,27.55-1.014,11.821-1.315,17.1.168,19.49,3.741,6.043,34.635,14.856,44.563,19.763,1.728.776,6.375,3.932,11.329,6.585,1.638.878,5.957.035,8.306-1.315a18.98,18.98,0,0,0,5.661-5.161c.234-.41.363-.866.558-1.3.332-.73.858-1.365,1.174-2.1C209.3,226.467,208.127,222.8,206.96,223.7Z",
    transform: "translate(-135.983 -129.432)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M136.443,195.22c-.7,7.19,30.538,9.757,30.905,1.486.125-2.785,1.756-31.143-4.245-37.869,0,0-1.042-4.19-1.307-4.12-6.94,1.814-16.315,8.926-20.017,16.966C139.337,176.978,137.488,184.456,136.443,195.22Z",
    transform: "translate(-134.685 -154.717)",
    fill: "#ffd940"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M242.095,179.71l-84.589-3.328a3.369,3.369,0,0,0-3.57,3.312,3.443,3.443,0,0,0,3.312,3.566l84.816,2.165S243.577,179.78,242.095,179.71Z",
    transform: "translate(-73.106 -47.957)",
    fill: "#262323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M164.635,187.338c1.986.847,7.471.792,8.532.683,1.787-.183,4.619-.925,4.334-5.434l-2.15-.172c-.808-2.079-1.927-4.518-2.489-4.919a2.489,2.489,0,0,0-2.641-.086,4.965,4.965,0,0,1-1.482.733c-.835.129-1.756-.57-2.6-.644a3.8,3.8,0,0,0-2.606.729c-.269.2-.367.211-.714-.066-1.221-.979-2.762-.542-2.895,1.038a8.044,8.044,0,0,0,.636,3.375A8.185,8.185,0,0,0,164.635,187.338Z",
    transform: "translate(-55.767 -45.917)",
    fill: "#fcbe9f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(148.179 385.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    style: {
      isolation: "isolate"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M202.378,202.89a4.575,4.575,0,0,0-2.114.675l-39.246,22.658a6.37,6.37,0,0,0-2.895,5.017l.168,60.87a3.368,3.368,0,0,0,.339,1.557l2.739,5.165,46.845-96.117Z",
    transform: "translate(-158.123 -202.711)",
    fill: "#e8e7e6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M179.885,223.365l-21.117-12.273.172,60.87c0,1.876.667,3.195,1.732,3.815l21.121,12.273Z",
    transform: "translate(-156.252 -178.405)",
    fill: "#bebbb9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M208.391,203.2c-1.319-.769-3.148-.659-5.165.5L163.98,226.365a11.505,11.505,0,0,0-5.212,9.035l21.117,12.273,49.627-32.2Z",
    transform: "translate(-156.252 -202.713)",
    fill: "#f0edea"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M164.128,208.754a11.556,11.556,0,0,0-5.36,9.121l21.117,12.273,10.026-6.507Z",
    transform: "translate(-156.252 -185.188)",
    fill: "#e8e7e6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M215.244,207.887c-1.159-2.188-3.683-2.719-6.6-1.034l-39.285,22.682a10.179,10.179,0,0,0-3.113,3.012,11.056,11.056,0,0,0-2.064,6l.176,60.87c0,2.723,1.4,4.272,3.406,4.213l5.836-.175,44.384-90.406Z",
    transform: "translate(-140.548 -193.586)",
    fill: "#e8e7e6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M213.114,210.854c-.008-3.133-2.232-4.4-4.955-2.832l-39.242,22.662a6.385,6.385,0,0,0-2.9,5.017l.172,60.874c0,2.3,1.631,3.222,3.632,2.068l39.851-23.009a7.944,7.944,0,0,0,3.609-6.25Z",
    transform: "translate(-135.215 -189.269)",
    fill: "#dddad7"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(30.368 1.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M175.092,209.889l-3.85-2.238-.01-3.463,3.85,2.238Z",
    transform: "translate(-150.458 -200.114)",
    fill: "#bebbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M174.14,205.382l-3.852-2.238,7.553,1.638,3.852,2.238Z",
    transform: "translate(-153.196 -203.144)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M169.765,217.575l-3.85-2.236-.008-9.666,3.852,2.239Z",
    transform: "translate(-165.907 -195.804)",
    fill: "#bebbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M169.759,215.251l-3.852-2.239L183,203.144l3.852,2.238Z",
    transform: "translate(-165.907 -203.144)",
    fill: "#f0edea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M183.987,203.717l7.553,1.638.01,3.665-3.873,2.234-.01-3.463L184,207.285l-13.241,7.646.017,6.084L166.9,223.25l-.006-9.663Z",
    transform: "translate(-163.043 -201.479)",
    fill: "#dddad7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M233.311,219.577l-21.843-12.61-6.345.088-46.934,27.1,2.59,9.854,26.636,16.327,37.427-19.468,11.02-17.771Z",
    transform: "translate(-157.931 -190.373)",
    fill: "#c0e87f",
    style: {
      mixBlendMode: "color",
      isolation: "isolate"
    }
  }), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(0.039 32.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M160.641,217.85l-2.508-3.909.129,45.6a3.367,3.367,0,0,0,.339,1.557l2.739,5.165,14.512-29.774Z",
    transform: "translate(-158.133 -202.862)",
    fill: "#b5d66e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M158.776,214.943l.14,45.847c0,1.876.667,3.195,1.732,3.815l21.121,12.273L180.186,227.3Z",
    transform: "translate(-156.267 -199.955)",
    fill: "#9ab758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M164.192,218.069l.133,45.925c0,2.723,1.4,4.272,3.406,4.213l5.836-.175,24.527-49.963Z",
    transform: "translate(-140.555 -190.886)",
    fill: "#b5d66e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M166.029,238.284l.133,47.4c0,2.3,1.631,3.222,3.632,2.068l39.851-23.009a7.944,7.944,0,0,0,3.609-6.25l-.137-47.392Z",
    transform: "translate(-135.225 -211.101)",
    fill: "#c0e87f"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(16.751 13.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cylinder",
    "data-name": "Axonometric Cylinder",
    transform: "translate(0 6.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M162.417,209.08v1.3a4.039,4.039,0,0,0,2.36,3.25,12.619,12.619,0,0,0,11.411,0c1.592-.921,2.384-2.13,2.364-3.336v-1.3Z",
    transform: "translate(-162.416 -204.378)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cylinder_face",
    "data-name": "Cylinder face",
    d: "M176.189,215.762a12.619,12.619,0,0,1-11.411,0c-3.148-1.818-3.148-4.767,0-6.585a12.6,12.6,0,0,1,11.411,0C179.337,211,179.337,213.944,176.189,215.762Z",
    transform: "translate(-162.417 -207.811)",
    fill: "#f0edea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cylinder-2",
    "data-name": "Axonometric Cylinder",
    transform: "translate(1.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M162.722,207.334V213.7a3.441,3.441,0,0,0,2.013,2.774,10.76,10.76,0,0,0,9.726,0,3.4,3.4,0,0,0,2.017-2.844V207.26Z",
    transform: "translate(-162.719 -203.325)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cylinder_face-2",
    "data-name": "Cylinder face",
    d: "M174.463,213.031a10.735,10.735,0,0,1-9.726,0c-2.688-1.549-2.688-4.065,0-5.618a10.759,10.759,0,0,1,9.726,0C177.151,208.966,177.151,211.482,174.463,213.031Z",
    transform: "translate(-162.721 -206.251)",
    fill: "#4c4254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M164.678,208.048a9.149,9.149,0,0,1,8.274,0,3.076,3.076,0,0,1,1.658,2.064,2.711,2.711,0,0,0-1.658-2.719,9.149,9.149,0,0,0-8.274,0,2.716,2.716,0,0,0-1.658,2.719A3.088,3.088,0,0,1,164.678,208.048Z",
    transform: "translate(-161.937 -205.81)",
    fill: "#342a3c"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(35.816 30.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M203.117,247.787,167.3,268.464V232.649l35.814-20.677Z",
    transform: "translate(-167.304 -206.186)",
    fill: "#80a89e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M203.117,218.8,167.3,239.479v-8.313l35.814-20.677Z",
    transform: "translate(-167.304 -210.488)",
    fill: "#edcb00"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(261.161 313.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_16",
    "data-name": 16
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(0 119.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M191.114,313.243a1.784,1.784,0,0,1-.425-.051,1.711,1.711,0,0,1-1.233-2.079,36.649,36.649,0,0,0,1.276-8.348,74.186,74.186,0,0,0-1.4-11.575c-2.2-13.248-5.22-31.4,4.42-44.025,6.979-9.137,25.479-31.428,25.666-31.65a1.707,1.707,0,1,1,2.626,2.181c-.183.222-18.636,22.463-25.572,31.549-8.746,11.446-5.867,28.748-3.769,41.388.808,4.853,1.506,9.047,1.447,12.195a40.044,40.044,0,0,1-1.381,9.129A1.705,1.705,0,0,1,191.114,313.243Z",
    transform: "translate(-187.084 -214.895)",
    fill: "#3d3838"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(12.144 141.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M190.764,254.626l33.948-4.752c3.355,1.182,2.411,9.2,1.26,12.546-.46,1.326-19.245,4.611-23.122,5.442a16.229,16.229,0,0,1-10.662-1.241c-.585-.324-1.767-1.053-1.724-1.884C190.464,264.737,190.737,255.714,190.764,254.626Z",
    transform: "translate(-189.425 -135.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M195.805,258.1a22.489,22.489,0,0,0,8.454-.047c3.581-.655,16.03-3.663,19.689-4.958l-1.252,3.87c-3.339,1.229-20.731,4.584-22.5,4.486-7.128.129-9.031-1.912-9.57-2.82a1.524,1.524,0,0,1-.183-.87l.1-2.7S190.554,257.058,195.805,258.1Z",
    transform: "translate(-189.488 -126.602)",
    fill: "#e58d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M197.961,267.36c-.913-14.86-.726-31.763,1.365-46.693,8.239,5.364,16.916,10.342,25.646,14.961-.507,15.031-1.752,33.644-2.149,40.7-.574,10.284-7.514,50.392-9.144,63.348-.882,7.775-23.637,5.009-23.481,1.315,1.791-42.293,2.856-50.438,6.07-62.255C196.978,276.138,198.125,270.044,197.961,267.36Z",
    transform: "translate(-190.197 -220.667)",
    fill: "#211921"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(42.344 142.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M199.449,277.559l-.023-1.3q-.14-7.613-.277-15.222a63.554,63.554,0,0,1,10.568-2.025l11.512,1.947c3.753,5.778,27.812,2.649,29.04,11.645,1.876,7.915-21.925,8.4-25.565,7.7-2.676-.511-7.073-1.038-9.152-1.631C215.554,278.679,199.457,278.1,199.449,277.559Z",
    transform: "translate(-194.425 -109.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M199.416,266.276c.952.905,12.316,1.853,15.039,2.095a174.186,174.186,0,0,0,26.45.542,12.093,12.093,0,0,0,7.022-2.329,4.4,4.4,0,0,0,1.99-4.166,4.52,4.52,0,0,1-.094,4.065,8.251,8.251,0,0,1-5.762,4.7c-6.585,1.482-22.876.4-26.571.074-3.632-.32-16.845-1.147-17.8-2.048a2.057,2.057,0,0,1-.441-1.521c-.012-.6-.023-1.194-.035-1.791A1.081,1.081,0,0,0,199.416,266.276Z",
    transform: "translate(-194.227 -100.027)",
    fill: "#e58d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M202.935,279.618c-2.352-13.178-5-26.434-5-39.835l32.825-18.991c.694,3.745,2.454,17.149,2.766,22.9,0,0,2.785,28.061.835,43.83-1.834,14.8-4.291,22.213-4.939,31.658-.9,13.057-.882,37.1-1.01,54.3-.07,9.1-25.861,8.747-26.353,1.268-3.476-52.97-.437-45.78,1.857-78.757A61.286,61.286,0,0,0,202.935,279.618Z",
    transform: "translate(-197.938 -220.792)",
    fill: "#211921"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M229.4,207.059c1.412-.066,3.761-.538,5.009.574,3.027,2.707,3.5,10.018.191,14.961-4.479,1.861-11.754,4.919-14.848,1.7.527-3.562,2.45-12.812,3.928-15.308C224.722,207.242,226.306,207.215,229.4,207.059Z",
    transform: "translate(-92.296 -118.764)",
    fill: "#fbbd9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(51.26 62.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M377.794,202.764v32.472L234.708,223.452l-.05-2.229Z",
    transform: "translate(-100.322 -193.108)",
    fill: "url(#linear-gradient-23)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M377.794,200.289v51.656L234.708,230.633l-.05-2.229Z",
    transform: "translate(-100.322 -200.289)",
    fill: "url(#linear-gradient-24)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M377.786,204.524v18.788l-143.094-5.438-.031-1.288Z",
    transform: "translate(-100.314 -188)",
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M377.78,206.026v7.09H234.674l-.011-.486Z",
    transform: "translate(-100.308 -183.642)",
    fill: "url(#linear-gradient-26)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M259.339,207.352l-32.567,1.978c-.882.074-.714,3.351.2,3.3l32.567-1.982C260.478,210.558,260.252,207.3,259.339,207.352Z",
    transform: "translate(-124.887 -179.8)",
    fill: "#bebbb9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M218.362,219.033c-.281.261-4.752,4.354-9.09,8.446a5.178,5.178,0,0,1-3.558,1.416h-3.574a1.924,1.924,0,0,1-1.315-3.32c2.4-2.282,4.849-4.44,7.4-6.683,1.791-1.576,4.6-4.412,6.6-5.68a2.922,2.922,0,0,1,1.791-.687l84.812-5.087c1.424-.074,1.7,6.464.523,6.577C301.828,214.028,218.362,219.033,218.362,219.033Z",
    transform: "translate(-200.224 -179.547)",
    fill: "#262323"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M196.543,198.133c-9.261,4.44-8.4,62.22.6,63.051,4.993.46,46.849-2.473,47.279-3.035,1.373-1.8,1.424-8.945-.925-10.592l-38.4-3.577s4.7-34.83,4.584-40C209.631,201.629,205.738,193.725,196.543,198.133Z",
    transform: "translate(-178.675 -148.019)",
    fill: "#fbbd9e"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M254.233,301.309c2.774,16.7-59.177,14.329-56.4-4.67.616-9.152,3.4-19.128,2.746-30.109-2.1-35.06-23.551-70.217,2.977-70.018a8.543,8.543,0,0,1,1.147,0,42.844,42.844,0,0,1,10.631,1.615l18.265,5.1a74.883,74.883,0,0,1,18.812,8.083c6.254,3.815,6.558,5.228,7.748,9.87C261.392,226,247.453,251.374,254.233,301.309Z",
    transform: "translate(-177.453 -148.948)",
    fill: "#ffd940"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M224.823,206.145c4.17,11.945,8.458,25.506,8.458,25.506L266.41,222.7l11.341,2.095c-1.752,2.688-6.234,8.005-8.758,8.973-7.783,2.836-31.225,11.337-41.5,14.54a6.349,6.349,0,0,1-7.424-2.942c-4.03-7.12-11.661-21.648-15.18-34.97C211.571,209.1,218.226,207.7,224.823,206.145Z",
    transform: "translate(-135.443 -120.963)",
    fill: "#fbbd9e"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M211.366,250.327c-6.394-13.042-8.914-31.662-5.754-42.683,3.433-12,12.546-5.1,14.005-3.257,2.087,2.637,12.523,20.544,16.412,32.368C239.739,242.224,215.029,255.3,211.366,250.327Z",
    transform: "translate(-137.278 -136.646)",
    fill: "#ffd940"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M189.128,240.926c.886-14.5,2.321-34.7,8.731-42.027,7.654-6.546,18.394,2.454,18.753,4.779.507,3.324.733,24.047-1.728,36.25C215.406,246.516,189.854,247.062,189.128,240.926Z",
    transform: "translate(-181.154 -148.788)",
    fill: "#ffd940"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M239.458,213.337c-2.844-3.09-2.516-5.165-3.012-8.005-.562-3.242-2.111-6.187-3.144-9.285-.956-2.852-.726-5.793-3.48-7.658a11.8,11.8,0,0,0-4.564-1.514q-1.223-.228-2.45-.453a22.35,22.35,0,0,0-4.1-.5,22.7,22.7,0,0,0-6.823,1.416c-4.088,1.3-8.481,2.821-10.9,6.363a18.644,18.644,0,0,0-2.013,4.42c-1.116,3.2-2.165,6.542-1.779,9.9.476,4.17,3.109,7.861,3.6,12.027a12.209,12.209,0,0,1-3.386,9.87c.156,2.064,1.155,3.913,3.839,5.337,4.077,2.664,10.049,2.4,14.914,2.6a5.1,5.1,0,0,0,1.74-.129c2.637-.823,2.68-5.2,5.313-6.047a4.893,4.893,0,0,1,1.845-.121,23.777,23.777,0,0,0,5.91-.019,6.6,6.6,0,0,0,4.779-3.152,10.629,10.629,0,0,0,.8-4.073,50.371,50.371,0,0,1,.729-5.622,3.07,3.07,0,0,1,.367-1.127c.7-1.108,2.664-1.362,2.684-2.668A2.432,2.432,0,0,0,239.458,213.337Z",
    transform: "translate(-157.993 -179.642)",
    fill: "#fbbd9e"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M219.566,217.912c-9.632.776-1.233,16.978-15.995,10.018-1.682-.792-1.759-1.241-1.962-2.786-.8-6.078-9.3-14.93-2.941-28.693,4.264-9.238,17.509-12.812,26.462-10.549,3.347.843,7.9,2.325,9.628,5.587a13.263,13.263,0,0,1,1.026,6.141,10.638,10.638,0,0,1-4.186,5.216c-2.255,1.541-2.7,1.666-3.031,5.372a31.365,31.365,0,0,1-2.189,9.016C225.047,220.511,223.892,217.565,219.566,217.912Z",
    transform: "translate(-160.279 -181.6)",
    fill: "#513120"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M227.517,218.22a23.08,23.08,0,0,1,3.281-6.85c2.224-3.4-2.637-5.348-5.118-.121a16.2,16.2,0,0,1-2.988,3.952c-1.857,1.639-1.533,3.445.125,5.528a2.33,2.33,0,0,0,2.668.683C226.682,220.888,227.165,219.476,227.517,218.22Z",
    transform: "translate(-87.44 -115.502)",
    fill: "#fbbd9e"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(35.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M214.824,214.946c5.692,0,23.154-3,23.914-10.818,0,0,0-24.261-29.306-19.1-16.9,4.779-12.831,23.922-12.831,23.922C197.217,211.9,203.346,214.946,214.824,214.946Z",
    transform: "translate(-196.172 -184.31)",
    fill: "#ffd940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M219.946,188.429s10.721.851,11.1,2.392c.5,1.99-.168,4.876-.683,6.648-.55,1.884-7.217,2.926-11.407,3.7-3.172.585-12.218.7-16.607,1.3C206.148,201.545,220.453,194.757,219.946,188.429Z",
    transform: "translate(-178.243 -172.36)",
    fill: "#fff643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M205.985,185.783c.074.726-1.131,1.436-2.692,1.592s-2.879-.308-2.953-1.03,1.135-1.44,2.7-1.592S205.915,185.062,205.985,185.783Z",
    transform: "translate(-184.088 -183.111)",
    fill: "#fff643"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(102.7 152.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M163.555,173.669c5.22.9,21.027-2.8,22.447-9.964,0,0-.527-23.532-25.381-20.368-16.085,2.871-14.076,20.973-14.076,20.973C146.846,167.088,159.076,172.9,163.555,173.669Z",
    transform: "translate(-146.465 -143.045)",
    fill: "#ffd940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M185.926,156.392c-3.8.449-8.189,2.235-12.932,5.189a13.818,13.818,0,0,1-12.73.882c-3.137-1.338-6.928-3.152-10.877-5.3,5.8,1.233,28.682-2.243,28.053-9.074C177.44,148.09,189.53,155.97,185.926,156.392Z",
    transform: "translate(-137.989 -128.408)",
    fill: "#fff643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M156.023,144.7c0,.675-1.182,1.225-2.641,1.225s-2.637-.55-2.637-1.225,1.182-1.225,2.637-1.225S156.023,144.018,156.023,144.7Z",
    transform: "translate(-134.05 -141.806)",
    fill: "#fff643"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(744.093 368.197)"
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(14.119 39.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(0 5.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M314.5,219.848l17.125-9.951,25.057,14.468-17.121,17.374Z",
    transform: "translate(-314.469 -209.896)",
    fill: "#ffd742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M320.945,223.555l17.121-9.951-.023,9.144L320.918,232.7Z",
    transform: "translate(-295.857 -199.142)",
    fill: "#f1b527"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M339.582,226.913l-.027,9.143-25.061-14.467.027-9.144Z",
    transform: "translate(-314.494 -202.501)",
    fill: "#dc9a11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(4.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M315.777,216.075l12.915-7.506,18.9,10.911-12.915,13.106Z",
    transform: "translate(-315.755 -208.57)",
    fill: "#ffd742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M320.634,218.871l12.915-7.505-.019,6.9-12.915,7.505Z",
    transform: "translate(-301.719 -200.458)",
    fill: "#f1b527"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M334.687,221.4l-.019,6.9-18.9-10.911.019-6.9Z",
    transform: "translate(-315.771 -202.991)",
    fill: "#dc9a11"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(0 16.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M318.556,207.2l-5.349,5.469a8.064,8.064,0,0,0-2.017,4.28l-.254,1.416c.293-1.631,11.8-3.273,9.168-11.618l-.546-1.681A4.017,4.017,0,0,1,318.556,207.2Z",
    transform: "translate(-310.695 -195.068)",
    fill: "#e8e7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M322.188,228.78,320,218.368a27.641,27.641,0,0,1-.624-5.8l.023-9.831-.226.148-3.09,13.061.581,6.651,2.38,36.6H322.1l.25-1.416a5.427,5.427,0,0,0,.086-.971l.07-25.089A14.289,14.289,0,0,0,322.188,228.78Z",
    transform: "translate(-295.754 -201.842)",
    fill: "#e8e7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M325.069,229.591l-2.189-10.412a26.707,26.707,0,0,1-.589-5.493l.035-10.915-4.283,2.489c-5.645,11.626-2.38,37.276,1.322,58.908l4.28-2.489a4.1,4.1,0,0,0,1.7-3.753l.074-25.093A15.483,15.483,0,0,0,325.069,229.591Z",
    transform: "translate(-298.904 -201.732)",
    fill: "#dddcdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M322.7,230.229l-2.185-10.412a26.172,26.172,0,0,1-.593-5.489l.031-10.919-2.126,1.225c-4.908,8.9-4.061,33.207-.956,57.312l1.354.484c2.7.96,4.748-.589,4.759-3.866l.07-25.092A15.774,15.774,0,0,0,322.7,230.229Z",
    transform: "translate(-300.813 -199.881)",
    fill: "#e8e7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M330.67,233.3l-2.181-10.412a27.713,27.713,0,0,1-.632-5.8l.031-9.831-8.228-4.752-.059,10.073a5.39,5.39,0,0,1-1.284,3.819l-5.345,5.469a8.57,8.57,0,0,0-2.036,6.066l-.062,21.819a10.778,10.778,0,0,0,4.888,8.469L326,264.131c2.707,1.564,4.912.308,4.923-2.8l.066-25.093A13.751,13.751,0,0,0,330.67,233.3Z",
    transform: "translate(-310.875 -202.504)",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(8.754)"
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M314.755,203.252l4.031,7.959,4.484-2.52.015-7.459Z",
    transform: "translate(-308.373 -190.173)",
    fill: "#f1b527"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M315.862,202.5v6.278l2.015-1.164.533-6.665Z",
    transform: "translate(-305.16 -190.999)",
    fill: "#de9f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(10.787 10.25)",
    style: {
      isolation: "isolate"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M323.833,215.591c-.421-.835-.893-1.83-1.4-2.965a112.432,112.432,0,0,1-4.572-11.6l-1.244.722a112.91,112.91,0,0,0,4.572,11.606c.5,1.135.975,2.13,1.373,2.93.125.265.086.46-.027.527l1.245-.726C323.9,216.02,323.935,215.825,323.833,215.591Z",
    transform: "translate(-313.749 -201.024)",
    fill: "#eae5e5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M324.763,215.739a102.874,102.874,0,0,1-5.945-14.536l-2.934,1.229c.706,2.29,5.891,11.653,8.54,13.763C324.771,216.406,324.95,216.109,324.763,215.739Z",
    transform: "translate(-315.884 -200.505)",
    fill: "#d0caca"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M315.922,201.525v4.821l3.878.924-1.238-3.905Z",
    transform: "translate(-304.987 -189.321)",
    fill: "#d0caca"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M321.306,199.836l-3.2,1.869,0,3.945,3.2-1.871Z",
    transform: "translate(-298.661 -194.219)",
    fill: "#f1b527"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M321.483,198.6a3.254,3.254,0,0,0-2.672.164l-5.274,3.062a3.287,3.287,0,0,1,2.68-.164l15.133,4.217,3.207-1.869Z",
    transform: "translate(-311.909 -198.397)",
    fill: "#ffd742"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M332.559,203.6l-15.133-4.217c-2.493-.784-4.268.741-4.276,3.671l-.031,9.417,8.267,4.759.765-2.848.2-5.516,10.217-1.319Z",
    transform: "translate(-313.119 -196.119)",
    fill: "#dc9a11"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M315.237,201.909l2.149-.286v8.448l-2.145.076Z",
    transform: "translate(-306.973 -189.035)",
    fill: "#eca900"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(0 26.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M330.056,211.777l-10.947-6.324-1.923-.316-4.057,2.341-.48,1.479.589,1.978s8.8,5.544,8.906,5.739,6.5-1,6.5-1l1.709-1.088Z",
    transform: "translate(-305.728 -205.137)",
    fill: "#c0e87f",
    style: {
      mixBlendMode: "color",
      isolation: "isolate"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M318.138,207.193l-.047-1.459-4.884,5a8.05,8.05,0,0,0-2.017,4.28l-.254,1.416c.222-1.248,7.014-2.508,9.008-6.772Z",
    transform: "translate(-310.695 -203.405)",
    fill: "#859e41"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M319.563,206.839l-.3.757-2.4,5.446c-.02-.023-.25-.254-.6-.6l2.263,34.834h3.055l.25-1.416a5.427,5.427,0,0,0,.086-.972l.07-25.089a14.288,14.288,0,0,0-.32-2.934Z",
    transform: "translate(-295.235 -200.199)",
    fill: "#b5d66e"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M322.929,207.033,315,211.609c-.016,12.133,2.087,26.914,4.361,40.19l4.28-2.489a4.1,4.1,0,0,0,1.7-3.753l.074-25.092a15.477,15.477,0,0,0-.355-3.242Z",
    transform: "translate(-298.902 -199.636)",
    fill: "#c0e87f"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M320.819,217.875l-2.146-10.209-2.809.332s-.273,1.319-.273,1.354l-.6,40.241,1.354.484c2.7.96,4.748-.589,4.759-3.866l.07-25.092A15.774,15.774,0,0,0,320.819,217.875Z",
    transform: "translate(-298.934 -197.8)",
    fill: "#b5d66e"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M330.67,222.973l-2.181-10.412-10.171-6.5-5.345,5.469a8.57,8.57,0,0,0-2.036,6.066l-.062,21.819a10.778,10.778,0,0,0,4.888,8.47L326,253.8c2.707,1.564,4.912.308,4.923-2.8l.066-25.092A13.75,13.75,0,0,0,330.67,222.973Z",
    transform: "translate(-310.875 -202.445)",
    fill: "#9ab758"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(1.848 38.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M327.822,240.4,311.349,230.9V208.821l16.474,9.509Z",
    transform: "translate(-311.349 -206.16)",
    fill: "#618078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M327.822,221.471l-16.474-9.509v-3.823l16.474,9.509Z",
    transform: "translate(-311.349 -208.139)",
    fill: "#b49a00"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarwash);
export default __webpack_public_path__ + "static/media/carwash.3e236bf5e9340b090246c70e8dd56cd8.svg";
export { ForwardRef as ReactComponent };